{
  "site.title": "Rentomax",
  "site.description": "Beheersplatform voor verhuurders",
  "appAdvertising.ariaLabel": "Gesponsorde ruimte",
  "appAdvertising.eyebrow": "Gesponsord",
  "appAdvertising.title": "Relevante partnercampagne voor verhuurders",
  "appAdvertising.body": "Deze subtiele plek is voorzien voor een verticale campagne of partnerboodschap die aansluit bij dagelijks vastgoedbeheer.",
  "appAdvertising.meta": "De admin kan deze ruimte platformbreed uitschakelen.",
  "language.label": "Taal",
  "language.nl": "Nederlands",
  "language.fr": "Frans",
  "language.en": "Engels",
  "language.de": "Duits",
  "common.loading": "Laden...",
  "common.today": "vandaag",
  "common.tomorrow": "morgen",
  "common.actions": "Acties",
  "common.details": "Details",
  "common.edit": "Bewerken",
  "common.delete": "Verwijderen",
  "common.download": "Download",
  "common.export": "Exporteer",
  "common.upload": "Uploaden",
  "common.generating": "Genereren...",
  "common.uploading": "Uploaden...",
  "common.add": "Toevoegen",
  "common.create": "Aanmaken",
  "common.save": "Opslaan",
  "common.saving": "Opslaan...",
  "common.deleting": "Verwijderen...",
  "common.cancel": "Annuleren",
  "common.close": "Sluiten",
  "common.copy": "Kopieren",
  "common.next": "Volgende",
  "common.previous": "Vorige",
  "common.finish": "Klaar",
  "common.confirm": "Bevestigen",
  "common.all": "Alle",
  "common.none": "Geen",
  "common.open": "Open",
  "common.completed": "Voltooid",
  "common.undo": "Ongedaan maken",
  "common.overdue": "Verlopen",
  "common.soon": "Binnenkort",
  "common.active": "Actief",
  "common.ended": "Beeindigd",
  "common.status": "Status",
  "common.type": "Type",
  "common.title": "Titel",
  "common.date": "Datum",
  "common.description": "Beschrijving",
  "common.notes": "Notities",
  "common.notesPlaceholder": "Afspraken, bijzondere clausules, links of interne notities...",
  "common.tags": "Tags",
  "common.address": "Adres",
  "common.property": "Pand",
  "common.tenant": "Huurder",
  "common.photos": "Foto's",
  "common.document": "Document",
  "common.documents": "Documenten",
  "common.reminder": "Reminder",
  "common.reminders": "Reminders",
  "common.deadline": "Deadline",
  "common.startDate": "Startdatum",
  "common.endDate": "Einddatum",
  "common.name": "Naam",
  "common.email": "E-mail",
  "common.phone": "Telefoon",
  "common.phoneNumber": "Telefoonnummer",
  "common.file": "Bestand",
  "common.category": "Categorie",
  "common.expiryDate": "Vervaldatum",
  "common.added": "Toegevoegd",
  "common.linkedTo": "Gekoppeld aan",
  "common.noLink": "- Geen koppeling -",
  "common.optional": "(optioneel)",
  "common.required": "*",
  "common.orSkip": "of sla deze stap over",
  "common.errorGeneric": "Er is een fout opgetreden. Probeer opnieuw.",
  "apiError.invalidRequest": "De aanvraag is onvolledig of ongeldig.",
  "apiError.badRequest": "De aanvraag kon niet worden verwerkt.",
  "apiError.unauthorized": "Je sessie kon niet worden gecontroleerd. Meld je opnieuw aan.",
  "apiError.paymentRequired": "Je abonnement laat deze actie nu niet toe.",
  "apiError.forbidden": "Je mag deze actie niet uitvoeren.",
  "apiError.notFound": "Het gevraagde item werd niet gevonden.",
  "apiError.conflict": "Deze actie kan nu niet worden voltooid.",
  "apiError.invalidOperation": "Deze actie kan niet worden voltooid.",
  "apiError.invalidVatNumber": "Het btw-nummer is ongeldig. Controleer het nummer en probeer opnieuw.",
  "apiError.argument": "Sommige gegevens zijn ongeldig. Controleer je invoer en probeer opnieuw.",
  "apiError.argumentOutOfRange": "Een van de waarden ligt buiten het toegelaten bereik.",
  "apiError.billingProvider": "De betaalprovider kon deze actie nu niet afronden.",
  "auth.login": "Inloggen",
  "auth.logout": "Uitloggen",
  "auth.startFree": "Gratis starten",
  "auth.dashboard": "Dashboard",
  "auth.successTitle": "Controleer je mailbox",
  "auth.loginWithEmail": "Stuur inloglink",
  "auth.loginWithGoogle": "Inloggen met Google",
  "auth.loginWithMicrosoft": "Inloggen met Microsoft",
  "auth.emailLabel": "E-mailadres",
  "auth.emailPlaceholder": "naam@voorbeeld.be",
  "auth.emailRequired": "Vul eerst je e-mailadres in.",
  "auth.emailLinkSent": "We hebben een inloglink naar je e-mailadres gestuurd.",
  "auth.emailLoginFailed": "Inloggen via e-mail is mislukt.",
  "auth.emailProvider": "E-mail",
  "auth.loggingIn": "Bezig met inloggen...",
  "auth.loginUnavailable": "Inloggen is momenteel niet beschikbaar. Probeer het later opnieuw.",
  "auth.noLoginProviders": "Er zijn momenteel geen inlogmethodes beschikbaar.",
  "auth.googleLoginFailed": "Inloggen met Google is mislukt.",
  "auth.microsoftLoginFailed": "Inloggen met Microsoft is mislukt.",
  "auth.authProviderDisabled": "Deze inlogmethode is momenteel uitgeschakeld.",
  "auth.accountBlocked": "Dit account is geblokkeerd. Neem contact op met de helpdesk.",
  "auth.signupDisabled": "Nieuwe accounts zijn momenteel uitgeschakeld. Neem contact op met de helpdesk.",
  "auth.signupNotification.body": "Laat je e-mailadres achter als je toestemming geeft om een eenmalige e-mail te ontvangen zodra Rentomax opnieuw beschikbaar is voor nieuwe gebruikers.",
  "auth.signupNotification.emailLabel": "E-mailadres",
  "auth.signupNotification.emailPlaceholder": "naam@voorbeeld.be",
  "auth.signupNotification.submit": "Houd me op de hoogte",
  "auth.signupNotification.successTitle": "Je staat op de lijst",
  "auth.signupNotification.success": "We sturen je een eenmalige e-mail zodra nieuwe accounts opnieuw toegelaten zijn.",
  "auth.signupNotification.invalidEmail": "Vul een geldig e-mailadres in.",
  "auth.signupNotification.missingContext": "We konden je aanmeldcontext niet meer bevestigen. Probeer opnieuw aan te melden.",
  "auth.signupNotification.saveError": "Je aanvraag kon niet opgeslagen worden. Probeer het opnieuw.",
  "auth.errorTitle": "Aanmelden niet mogelijk",
  "accessGuard.checkFailed": "We konden je toegang nu niet controleren. Probeer het zo opnieuw.",
  "auth.countryNotAllowed": "Rentomax is momenteel nog niet beschikbaar in jouw land.",
  "auth.platformCountryNotAllowed": "Je sessie is gestopt omdat toegang vanuit jouw land niet toegelaten is op Rentomax.",
  "auth.countryUnverified": "We konden je land niet verifiëren. Probeer het later opnieuw.",
  "country.AT": "Oostenrijk",
  "country.BE": "Belgie",
  "country.BG": "Bulgarije",
  "country.HR": "Kroatie",
  "country.CY": "Cyprus",
  "country.CZ": "Tsjechie",
  "country.DK": "Denemarken",
  "country.EE": "Estland",
  "country.FI": "Finland",
  "country.FR": "Frankrijk",
  "country.DE": "Duitsland",
  "country.GR": "Griekenland",
  "country.HU": "Hongarije",
  "country.IE": "Ierland",
  "country.IT": "Italie",
  "country.LV": "Letland",
  "country.LT": "Litouwen",
  "country.LU": "Luxemburg",
  "country.MT": "Malta",
  "country.NL": "Nederland",
  "country.PL": "Polen",
  "country.PT": "Portugal",
  "country.RO": "Roemenie",
  "country.SK": "Slowakije",
  "country.SI": "Slovenie",
  "country.ES": "Spanje",
  "country.SE": "Zweden",
  "nav.dashboard": "Dashboard",
  "nav.calendar": "Kalender",
  "nav.properties": "Panden",
  "nav.tenants": "Huurders",
  "nav.documents": "Documenten",
  "nav.reminders": "Reminders",
  "nav.damageReports": "Schademeldingen",
  "nav.waitinglist": "Wachtlijst",
  "nav.contractors": "Aannemers",
  "nav.contracts": "Tijdslijn",
  "nav.features": "Functies",
  "nav.pricing": "Prijzen",
  "nav.help": "Help",
  "nav.tenantActiveAgreements": "Actieve huurovereenkomsten",
  "nav.tenantUpcomingAgreements": "Toekomstige huurovereenkomsten",
  "nav.tenantApplications": "Kandidaatstellingen",
  "nav.tenantPastAgreements": "Afgelopen huurovereenkomsten",
  "footer.tagline": "Het slimme platform voor verhuurders in Belgie en Nederland.",
  "footer.product": "Product",
  "footer.support": "Support",
  "footer.contact": "Contact",
  "footer.legal": "Legal",
  "footer.privacy": "Privacy Policy",
  "footer.terms": "Terms of Service",
  "footer.copyright": "Alle rechten voorbehouden.",
  "legal.eyebrow": "Legal",
  "legal.updated": "Laatst bijgewerkt: 23 juni 2026",
  "legal.common.companyLabel": "Bedrijf",
  "legal.common.addressLabel": "Vestigingsland",
  "legal.common.companyNumberLabel": "Ondernemingsnummer",
  "legal.common.vatLabel": "BTW-nummer",
  "legal.common.emailLabel": "E-mail",
  "legal.common.websiteLabel": "Website",
  "legal.privacy.hero.title": "Privacy Policy",
  "legal.privacy.hero.body": "Deze privacy policy beschrijft hoe Ceustermans IT BV persoonsgegevens verwerkt in verband met Rentomax en de publieke website.",
  "legal.privacy.controller.title": "1. Verwerkingsverantwoordelijke",
  "legal.privacy.controller.body": "Ceustermans IT BV is de verwerkingsverantwoordelijke voor de persoonsgegevens die via Rentomax en de publieke website worden verwerkt.",
  "legal.privacy.scope.title": "2. Op welke gegevens heeft dit beleid betrekking?",
  "legal.privacy.scope.body": "Dit beleid geldt voor persoonsgegevens die we verwerken wanneer je de website bezoekt, een account aanmaakt, inlogt, support vraagt, een proefperiode of abonnement gebruikt, of gegevens opslaat in Rentomax.",
  "legal.privacy.scope.item1": "Identiteits- en contactgegevens zoals naam, e-mailadres, telefoonnummer en adresgegevens.",
  "legal.privacy.scope.item2": "Account- en profielgegevens zoals accounttype, taalvoorkeur, sign-in provider en onboardingstatus.",
  "legal.privacy.scope.item3": "Abonnements- en facturatiegegevens zoals gekozen plan, betaalstatus, facturen, creditnota's en bedrijfs- of btw-gegevens.",
  "legal.privacy.scope.item4": "Gebruikersinhoud die je in de dienst opslaat, zoals panden, huurders, overeenkomsten, documenten, foto's, reminders en meldingen.",
  "legal.privacy.scope.item5": "Technische gegevens zoals IP-adres, apparaat- en browserinformatie, loggegevens en lokale voorkeuren die nodig zijn voor beveiliging en werking.",
  "legal.privacy.collection.title": "3. Hoe verzamelen we persoonsgegevens?",
  "legal.privacy.collection.item1": "Rechtstreeks van jou wanneer je formulieren invult, inlogt, support aanvraagt of gegevens in de app opslaat.",
  "legal.privacy.collection.item2": "Via Google of Microsoft wanneer je ervoor kiest om met een van die providers in te loggen.",
  "legal.privacy.collection.item3": "Via betaal- en facturatiepartners wanneer een proefperiode, betaling, abonnementswijziging of terugbetaling wordt verwerkt.",
  "legal.privacy.collection.item4": "Automatisch via logs, cookies en lokale opslag die nodig zijn om de website en app veilig en bruikbaar te houden.",
  "legal.privacy.google.title": "4. Google user data voor sign-in",
  "legal.privacy.google.body1": "Als je kiest voor Sign in with Google, vraagt Rentomax alleen de scopes openid, email en profile. Via die scopes ontvangen we je Google account-ID, e-mailadres en profielnaam.",
  "legal.privacy.google.body2": "We gebruiken deze Google user data uitsluitend om je te authenticeren, je Rentomax-account aan te maken of te koppelen, je gekozen loginprovider te bewaren en je naam of e-mailadres in je account te tonen. We gebruiken deze data niet voor advertenties en niet om algemene AI- of ML-modellen te trainen.",
  "legal.privacy.google.item1": "De autorisatiecode en tokens die Google tijdens sign-in terugstuurt, gebruiken we alleen tijdens het inlogproces op onze backend om je identiteit te verifiëren.",
  "legal.privacy.google.item2": "We gebruiken de Google access token niet om Gmail, Drive, Calendar, Contacts of andere Google APIs te lezen of te wijzigen, en we bewaren die access token niet na het inloggen.",
  "legal.privacy.google.item3": "De Google account-ID, het e-mailadres en de profielnaam kunnen we opslaan in je Rentomax-accountrecord zolang dat nodig is voor accounttoegang, beveiliging, support en accountherstel, of langer als een wettelijke bewaarplicht dat vereist.",
  "legal.privacy.purposes.title": "5. Waarom verwerken we persoonsgegevens en op welke rechtsgrond?",
  "legal.privacy.purposes.item1": "Om je account aan te maken, te authenticeren en toegang te geven tot Rentomax. Rechtsgrond: uitvoering van een overeenkomst of precontractuele stappen.",
  "legal.privacy.purposes.item2": "Om de dienst te leveren, gegevens op te slaan, dossiers te tonen en functies zoals documenten, foto's, herinneringen en tenant flows te laten werken. Rechtsgrond: uitvoering van een overeenkomst.",
  "legal.privacy.purposes.item3": "Om betalingen, abonnementen, facturen, terugbetalingen en verplichte boekhoudkundige administratie te beheren. Rechtsgrond: uitvoering van een overeenkomst en wettelijke verplichtingen.",
  "legal.privacy.purposes.item4": "Om supportvragen te beantwoorden en operationele berichten te sturen. Rechtsgrond: gerechtvaardigd belang en, waar relevant, precontractuele stappen.",
  "legal.privacy.purposes.item5": "Om de website en app te beveiligen, misbruik te voorkomen, incidenten te onderzoeken en prestaties te bewaken. Rechtsgrond: gerechtvaardigd belang.",
  "legal.privacy.purposes.item6": "Om je een eenmalige melding te sturen wanneer nieuwe accounttoegang opnieuw wordt geopend, als je daar expliciet om vraagt. Rechtsgrond: toestemming.",
  "legal.privacy.cookies.title": "6. Cookies, lokale opslag en sign-in technologie",
  "legal.privacy.cookies.body1": "Rentomax gebruikt functionele cookies en lokale opslag om de website en app te laten werken, bijvoorbeeld voor taalkeuze, sessiebeveiliging, inlogstatus, terugverwijzingen na login, toestemmingskeuzes en interfacevoorkeuren.",
  "legal.privacy.cookies.body2": "Wanneer je kiest voor Google- of Microsoft-login, laden we de benodigde sign-in scripts van die providers om authenticatie mogelijk te maken. Deze providers verwerken daarbij ook gegevens onder hun eigen privacyvoorwaarden.",
  "legal.privacy.sharing.title": "7. Met wie delen we persoonsgegevens?",
  "legal.privacy.sharing.body": "We verkopen je persoonsgegevens niet. We delen persoonsgegevens alleen wanneer dat nodig is voor de levering van Rentomax, voor betalingen, hosting, e-mailverzending, beveiliging of wanneer we daartoe wettelijk verplicht zijn.",
  "legal.privacy.sharing.item1": "Betaalverwerking en abonnementsbeheer via Mollie.",
  "legal.privacy.sharing.item2": "Authenticatie via Google en Microsoft wanneer je die loginmethode gebruikt.",
  "legal.privacy.sharing.item3": "Opslag en infrastructuur via Supabase en Azure.",
  "legal.privacy.sharing.item4": "Transactionele e-mailverzending via Resend.",
  "legal.privacy.sharing.item5": "Professionele adviseurs, bevoegde autoriteiten of rechtbanken wanneer dat redelijk nodig of wettelijk vereist is.",
  "legal.privacy.transfers.title": "8. Internationale doorgiften",
  "legal.privacy.transfers.body": "Sommige leveranciers of hun subverwerkers kunnen persoonsgegevens buiten de Europese Economische Ruimte verwerken. In dat geval vertrouwen we op een geldige doorgiftegrondslag, zoals een adequaatheidsbesluit of passende contractuele waarborgen.",
  "legal.privacy.retention.title": "9. Bewaartermijnen",
  "legal.privacy.retention.body1": "We bewaren persoonsgegevens niet langer dan nodig voor de doeleinden waarvoor ze zijn verzameld, tenzij een langere bewaartermijn wettelijk vereist of operationeel gerechtvaardigd is.",
  "legal.privacy.retention.item1": "Account- en dossiergegevens bewaren we in principe zolang het account actief is en daarna zolang nodig voor afsluiting, back-ups, geschillen of wettelijke verplichtingen.",
  "legal.privacy.retention.item2": "Facturatie- en transactiedocumenten bewaren we zolang de toepasselijke boekhoudkundige en fiscale regels dat vereisen.",
  "legal.privacy.retention.item3": "Supportverzoeken, beveiligingslogs en technische back-ups bewaren we zolang dat redelijk nodig is voor support, beveiliging en herstel.",
  "legal.privacy.security.title": "10. Beveiliging",
  "legal.privacy.security.body": "We nemen redelijke technische en organisatorische maatregelen om persoonsgegevens te beschermen tegen verlies, ongeoorloofde toegang, misbruik, wijziging of openbaarmaking. Geen enkele methode van opslag of overdracht is echter volledig risicoloos.",
  "legal.privacy.rights.title": "11. Je rechten",
  "legal.privacy.rights.body": "Onder de GDPR heb je, afhankelijk van de situatie, recht op inzage, rectificatie, wissing, beperking van verwerking, overdraagbaarheid van gegevens en bezwaar tegen bepaalde verwerkingen. Wanneer verwerking op toestemming berust, kan je die toestemming ook intrekken.",
  "legal.privacy.rights.body2": "Je kan je verzoek sturen naar <a href=\"mailto:admin@rentomax.be\">admin@rentomax.be</a>. We kunnen redelijke verificatie vragen voordat we op een verzoek ingaan.",
  "legal.privacy.complaints.title": "12. Klachten en contact",
  "legal.privacy.complaints.body1": "Als je vragen hebt over deze privacy policy of over de verwerking van persoonsgegevens door Rentomax, neem dan contact op via <a href=\"mailto:admin@rentomax.be\">admin@rentomax.be</a>.",
  "legal.privacy.complaints.body2": "Je hebt ook het recht om een klacht in te dienen bij de Belgische Gegevensbeschermingsautoriteit of bij de toezichthouder in het EU-land waar je woont of werkt.",
  "legal.terms.hero.title": "Terms of Service",
  "legal.terms.hero.body": "Deze gebruiksvoorwaarden regelen je toegang tot en gebruik van Rentomax als administratieve softwaredienst voor verhuurders en verhuurbedrijven.",
  "legal.terms.provider.title": "1. Aanbieder",
  "legal.terms.provider.body": "Rentomax wordt aangeboden door Ceustermans IT BV, Belgie, ondernemingsnummer 0783 289 846 en btw-nummer BE0783 289 846.",
  "legal.terms.provider.body2": "Voor vragen over deze voorwaarden kan je contact opnemen via <a href=\"mailto:admin@rentomax.be\">admin@rentomax.be</a>.",
  "legal.terms.scope.title": "2. Dienst en toepassingsgebied",
  "legal.terms.scope.body1": "Rentomax is een online administratieve tool voor verhuurders, zelfstandige verhuurders, bedrijven en andere verhuurbedrijven. De dienst helpt gebruikers om panden, huurders, overeenkomsten, documenten, reminders, events en gerelateerde dossiers te organiseren.",
  "legal.terms.scope.body2": "Rentomax is geen juridisch, fiscaal, boekhoudkundig of compliance-product en geeft geen juridisch advies of automatische wettelijke beoordelingen.",
  "legal.terms.accounts.title": "3. Accounts en toegang",
  "legal.terms.accounts.item1": "Je bent verantwoordelijk voor de juistheid van de accountgegevens die je verstrekt en voor het veilig gebruik van je account.",
  "legal.terms.accounts.item2": "Je mag Rentomax alleen gebruiken voor legitieme administratieve doeleinden binnen je eigen organisatie, activiteit of verhuurcontext.",
  "legal.terms.accounts.item3": "Je blijft verantwoordelijk voor alle handelingen die via je account gebeuren, tenzij je een beveiligingsincident tijdig aan ons meldt.",
  "legal.terms.accounts.item4": "Wij mogen toegang weigeren, beperken of blokkeren wanneer dat redelijk nodig is om fraude, misbruik, veiligheidsincidenten of contractbreuk te voorkomen.",
  "legal.terms.acceptableUse.title": "4. Toegestaan gebruik",
  "legal.terms.acceptableUse.item1": "Je mag de dienst niet gebruiken op een manier die onwettig, misleidend, schadelijk of inbreukmakend is.",
  "legal.terms.acceptableUse.item2": "Je mag geen virussen, malware, ongeoorloofde scripts of andere schadelijke code uploaden of verspreiden via Rentomax.",
  "legal.terms.acceptableUse.item3": "Je mag niet proberen om de dienst, onderliggende systemen of accounts van andere gebruikers ongeoorloofd te benaderen, te verstoren of te reverse engineeren, behalve voor zover dwingend recht dat toestaat.",
  "legal.terms.acceptableUse.item4": "Je mag de dienst niet gebruiken om persoonsgegevens te verwerken als je daarvoor geen geldige grondslag of toestemming hebt waar die vereist is.",
  "legal.terms.customerData.title": "5. Jouw gegevens en inhoud",
  "legal.terms.customerData.body1": "Tussen jou en Ceustermans IT BV blijf jij eigenaar van de inhoud en gegevens die je in Rentomax invoert of uploadt, voor zover de wet dat toelaat.",
  "legal.terms.customerData.body2": "Je verklaart dat je de nodige rechten en toelatingen hebt om die gegevens in Rentomax op te slaan en te verwerken. Je bent verantwoordelijk voor de rechtmatigheid, kwaliteit en juistheid van die gegevens.",
  "legal.terms.billing.title": "6. Proefperiode, abonnementen en betalingen",
  "legal.terms.billing.item1": "Rentomax kan een gratis proefperiode aanbieden. Na afloop van een proefperiode kan voor verder gebruik een betaald plan nodig zijn.",
  "legal.terms.billing.item2": "Betaalde abonnementen lopen per overeengekomen facturatie-interval en worden automatisch verlengd totdat ze worden geannuleerd.",
  "legal.terms.billing.item3": "Prijzen, planlimieten en inbegrepen opslag worden weergegeven op de pricingpagina of in de accountomgeving.",
  "legal.terms.billing.item4": "Betalingen, terugbetalingen en abonnementsverwerking kunnen via externe betaalproviders verlopen.",
  "legal.terms.cancellation.title": "7. Opzegging, wijzigingen en herroepingsrecht",
  "legal.terms.cancellation.item1": "Je kan een betaald abonnement opzeggen via de beschikbare account- of supportkanalen. Een gewone opzegging stopt toekomstige verlengingen aan het einde van de lopende betaalde periode.",
  "legal.terms.cancellation.item2": "Upgrades kunnen onmiddellijk ingaan. Downgrades of verlagingen kunnen pas ingaan vanaf een volgende betaalde periode, afhankelijk van het gekozen plan en interval.",
  "legal.terms.cancellation.item3": "Als je als consument een eerste betaald abonnement afsluit, kan een wettelijk toepasselijk herroepingsrecht binnen 14 dagen na de start van dat eerste betaalde abonnement worden uitgeoefend. Als dat recht van toepassing is, storten we het betaalde bedrag terug en stoppen we toekomstige verlengingen.",
  "legal.terms.cancellation.item4": "Wij kunnen prijzen of planlimieten wijzigen voor toekomstige periodes. Als zo'n wijziging op jouw bestaande betaalde abonnement van toepassing is, proberen we je daar vooraf over te informeren.",
  "legal.terms.availability.title": "8. Beschikbaarheid en wijzigingen aan de dienst",
  "legal.terms.availability.body1": "We doen redelijke inspanningen om Rentomax beschikbaar, veilig en bruikbaar te houden, maar we garanderen geen ononderbroken of foutloze beschikbaarheid.",
  "legal.terms.availability.body2": "We mogen de dienst, functies, gebruikersinterface, technische infrastructuur of ondersteunde integraties van tijd tot tijd aanpassen, verbeteren, beperken of stopzetten.",
  "legal.terms.ip.title": "9. Intellectuele eigendom",
  "legal.terms.ip.body": "Alle rechten op Rentomax, inclusief software, merk, vormgeving, documentatie en niet door gebruikers aangeleverde inhoud, blijven eigendom van Ceustermans IT BV of haar licentiegevers. Deze voorwaarden geven je alleen een beperkte, herroepbare, niet-exclusieve gebruikslicentie voor de duur van je rechtmatige gebruik van de dienst.",
  "legal.terms.liability.title": "10. Garanties en aansprakelijkheid",
  "legal.terms.liability.body1": "Rentomax wordt geleverd op basis van redelijke professionele inspanningen. Voor zover wettelijk toegestaan, worden impliciete garanties uitgesloten.",
  "legal.terms.liability.body2": "Ceustermans IT BV is niet aansprakelijk voor indirecte schade, gevolgschade, winstderving, verlies van kansen, verlies van data door handelingen van de gebruiker of beslissingen die uitsluitend op basis van de software-output worden genomen.",
  "legal.terms.liability.body3": "Niets in deze voorwaarden beperkt aansprakelijkheid die onder dwingend recht niet rechtsgeldig kan worden uitgesloten of beperkt.",
  "legal.terms.termination.title": "11. Beeindiging",
  "legal.terms.termination.body": "We mogen je toegang schorsen of beeindigen als je deze voorwaarden wezenlijk schendt, de dienst misbruikt, veiligheidsrisico's veroorzaakt of betalingen onbetaald laat, voor zover dat onder de omstandigheden redelijk is.",
  "legal.terms.law.title": "12. Toepasselijk recht en geschillen",
  "legal.terms.law.body": "Op deze voorwaarden is Belgisch recht van toepassing. Bevoegde rechtbanken in Belgie zijn bevoegd, tenzij dwingend consumentenrecht een andere bevoegde rechter voorschrijft.",
  "richText.bold": "Vetgedrukt",
  "richText.bulletList": "Lijst met opsommingstekens",
  "richText.numberedList": "Genummerde lijst",
  "richText.link": "Link toevoegen",
  "richText.linkPrompt": "Voer een volledige link in",
  "landing.hero.title": "Alles voor je verhuurpanden,<br>op één plek.",
  "landing.hero.subtitle": "Rentomax is het beheerplatform voor verhuurders in België en Nederland. Houd je panden, huurders, documenten en deadlines overzichtelijk bij, zonder gedoe.",
  "landing.hero.primary": "Gratis starten",
  "landing.hero.secondary": "Ontdek features",
  "landing.features.title": "Een compleet platform voor je verhuuradministratie",
  "landing.features.subtitle": "Van je eerste pand tot een brede portefeuille: beheer gebouwen, units, huurders, overeenkomsten, documenten, opvolging en export in een centrale werkplek.",
  "landing.feature.dashboard.title": "Dashboard en portefeuilleoverzicht",
  "landing.feature.dashboard.body": "Zie meteen wat aandacht vraagt met samenvattingen van bezetting, open opvolgingen, aankomende einddatums en recente activiteit.",
  "landing.feature.portfolio.title": "Gebouwen, panden en units",
  "landing.feature.portfolio.body": "Beheer losse panden of volledige gebouwen met meerdere units. Elke unit houdt zijn eigen dossier, terwijl gedeelde gebouwinformatie centraal blijft.",
  "landing.feature.tenants.title": "Huurders en kandidaat-huurders",
  "landing.feature.tenants.body": "Bewaar contactgegevens, statussen, notities en historiek per contact. Zo houd je bewonerswissels en opvolging netjes bij.",
  "landing.feature.documents.title": "Overeenkomsten en documenten",
  "landing.feature.documents.body": "Koppel contracten, attesten, bijlagen en andere bestanden aan het juiste pand, gebouw, unit of de juiste huurder. Alles blijft terugvindbaar in een duidelijk dossier.",
  "landing.feature.condition.title": "Plaatsbeschrijvingen met foto's",
  "landing.feature.condition.body": "Leg de staat van je pand kamer per kamer vast bij in- en uitcheck. Werk met checklists, notities en foto's die meteen aan het juiste dossier hangen.",
  "landing.feature.welcome.title": "Welkomstpagina per huurder",
  "landing.feature.welcome.body": "Deel praktische verhuis- en gebruiksinformatie via een persoonlijke link die jij activeert en beheert voor elke nieuwe huurder.",
  "landing.feature.issues.title": "Schade- en issuemeldingen",
  "landing.feature.issues.body": "Laat actieve huurders problemen of schade registreren met foto's, zodat jij elke melding per overeenkomst kunt opvolgen.",
  "landing.feature.payments.title": "Handmatige betaalopvolging",
  "landing.feature.payments.body": "Noteer per periode of huur ontvangen is, bekijk de historiek en houd openstaande maanden zichtbaar zonder bankkoppelingen.",
  "landing.feature.calendar.title": "Herinneringen, vervaldata en kalender",
  "landing.feature.calendar.body": "Plan reminders, volg einddatums op en bekijk alle belangrijke momenten uit je portefeuille in een gedeeld kalenderoverzicht.",
  "landing.feature.export.title": "PDF-export van dossiers",
  "landing.feature.export.body": "Stel een export samen per pand of huurder en bundel de juiste onderdelen in een PDF voor intern gebruik of overdracht.",
  "landing.cta.title": "Klaar om je verhuurpanden beter te beheren?",
  "landing.cta.body": "Start vandaag nog gratis. Geen creditcard nodig.",
  "landing.cta.button": "Maak je account aan",
  "landing.useCases.title": "Software voor verhuurders die overzicht willen zonder losse tools",
  "landing.useCases.subtitle": "Rentomax bundelt je dagelijkse verhuuradministratie in een werkplek die meegroeit van een eerste pand tot een bredere portefeuille.",
  "landing.useCase.admin.title": "Van pandstatus tot huurderdossier op een vaste plek",
  "landing.useCase.admin.body": "Gebruik Rentomax als centrale software voor verhuurders om panden, units, huurders, contracten en notities per dossier samen te houden.",
  "landing.useCase.documents.title": "Minder zoeken tussen documenten, foto's en vervaldata",
  "landing.useCase.documents.body": "Koppel documenten, plaatsbeschrijvingen, foto's en herinneringen aan het juiste pand of de juiste huurder zodat opvolging sneller verloopt.",
  "landing.useCase.followup.title": "Meer grip op opvolging, onboarding en planning",
  "landing.useCase.followup.body": "Werk met reminders, kalender, onboarding en exports om je verhuuradministratie consistent te houden naarmate je portefeuille groeit.",
  "landing.guides.title": "Verken Rentomax via functies, prijzen en hulp",
  "landing.guides.subtitle": "Elke publieke pagina helpt je een ander deel van het platform te beoordelen: wat je beheert, welk plan past en hoe de dagelijkse werkwijze eruitziet.",
  "landing.guides.features.title": "Bekijk wat je met Rentomax beheert",
  "landing.guides.features.body": "Ontdek hoe het platform panden, huurders, documenten, plaatsbeschrijvingen, reminders en PDF-export samenbrengt voor verhuurders.",
  "landing.guides.features.button": "Naar de functies",
  "landing.guides.pricing.title": "Vergelijk prijzen voor verhuurdersoftware",
  "landing.guides.pricing.body": "Zie welk plan past bij een enkel pand, een groeiende portefeuille of een professioneler verhuurbeheer.",
  "landing.guides.pricing.button": "Bekijk de prijzen",
  "landing.guides.help.title": "Lees hoe je met Rentomax werkt",
  "landing.guides.help.body": "Gebruik het helpcenter voor onboarding, gebouwen met units, documentopvolging, reminders en supportvragen.",
  "landing.guides.help.button": "Open het helpcenter",
  "login.page.title": "Inloggen",
  "login.heading": "Inloggen",
  "login.body": "Log in om je panden, huurders en documenten te beheren.",
  "login.footer": "Nog geen account? Door in te loggen maak je automatisch een account aan.",
  "pricing.hero.title": "Eenvoudige, transparante prijzen",
  "pricing.hero.subtitle": "Probeer Rentomax 14 dagen gratis. Geen creditcard nodig.",
  "pricing.toggle.monthly": "Maandelijks",
  "pricing.toggle.yearly": "Jaarlijks",
  "pricing.toggle.saveLabel": "2 mnd gratis",
  "pricing.trial.title": "Gratis proefperiode",
  "pricing.trial.desc": "Ontdek het platform vrijblijvend gedurende 2 weken.",
  "pricing.starter.desc": "Ideaal als je een pand verhuurt.",
  "pricing.pro.desc": "Voor verhuurders met meerdere panden.",
  "pricing.business.desc": "Voor professionele vastgoedbeheerders.",
  "pricing.custom.title": "Op maat",
  "pricing.custom.desc": "Meer dan 5 panden? We voorzien een oplossing op maat.",
  "pricing.badge.popular": "Populair",
  "pricing.button.start": "Gratis starten",
  "pricing.button.getStarted": "Aan de slag",
  "pricing.button.choosePro": "Kies Pro",
  "pricing.button.chooseBusiness": "Kies Business",
  "pricing.button.contactSales": "Contacteer ons",
  "pricing.questions.title": "Nog vragen?",
  "pricing.questions.body": "Neem gerust contact met ons op. We helpen je graag verder.",
  "pricing.questions.button": "Contacteer ons",
  "pricing.trial.period": "/ 14 dagen",
  "pricing.period.monthly": "/maand incl. btw",
  "pricing.period.yearly": "/jaar incl. btw",
  "pricing.feature.fullAccess": "Volledige toegang tot alle features",
  "pricing.feature.documents": "Documentopslag",
  "pricing.feature.remindersTimeline": "Reminders en timeline",
  "pricing.feature.dashboard": "Dashboard",
  "pricing.feature.prioritySupport": "Prioritaire support",
  "pricing.feature.dedicatedSupport": "Dedicated support",
  "pricing.starter.feature.properties": "1 pand",
  "pricing.trial.feature.storage": "1 GB opslag, goed voor ongeveer 500 documenten of foto's",
  "pricing.starter.feature.storage": "1 GB opslag, goed voor ongeveer 500 documenten of foto's",
  "pricing.pro.feature.properties": "Tot 3 panden",
  "pricing.pro.feature.storage": "3 GB opslag, goed voor ongeveer 1.500 documenten of foto's",
  "pricing.business.feature.properties": "Tot 5 panden",
  "pricing.business.feature.storage": "10 GB opslag, goed voor ongeveer 5.000 documenten of foto's",
  "pricing.custom.feature.properties": "Onbeperkt panden",
  "pricing.custom.feature.includes": "Alles van Business",
  "pricing.custom.feature.storage": "Opslagruimte op maat",
  "pricing.custom.feature.price": "Prijs op maat",
  "pricing.storageEstimateNote": "Schatting op basis van gemiddeld 2 MB per document of foto. PDF's tellen meestal lichter door, foto's soms zwaarder.",
  "pricing.fit.title": "Welk plan past bij jouw verhuuradministratie?",
  "pricing.fit.subtitle": "Gebruik deze richtlijn om sneller te kiezen op basis van het aantal panden, de hoeveelheid opvolging en de schaal van je portefeuille.",
  "pricing.fit.starter.title": "Starter voor een eerste pand of compacte portefeuille",
  "pricing.fit.starter.body": "Kies Starter als je vooral een pand, de gekoppelde huurder, documenten en reminders op een vaste plek wilt beheren.",
  "pricing.fit.pro.title": "Pro voor verhuurders met meerdere panden",
  "pricing.fit.pro.body": "Kies Pro als je meerdere dossiers tegelijk opvolgt en meer ruimte wilt voor documenten, plaatsbeschrijvingen en dagelijkse opvolging.",
  "pricing.fit.business.title": "Business voor een bredere of professionelere werking",
  "pricing.fit.business.body": "Kies Business als je verhuuradministratie over meerdere panden heen structureert en meer opslag en ondersteuning nodig hebt.",
  "pricing.faq.title": "Veelgestelde vragen over prijzen en plannen",
  "pricing.faq.intro": "Deze korte antwoorden helpen je inschatten welk plan het beste past bij je panden, documenten en dagelijkse opvolging.",
  "pricing.faq.starter.question": "Voor wie is Starter het meest geschikt?",
  "pricing.faq.starter.answer": "Starter past bij verhuurders die een eerste pand of een beperkt verhuurdossier centraal willen beheren zonder onnodige complexiteit.",
  "pricing.faq.scale.question": "Wanneer kies ik beter Pro of Business?",
  "pricing.faq.scale.answer": "Pro en Business passen beter zodra je meerdere panden beheert, meer opslag nodig hebt en opvolging over meerdere dossiers heen wilt structureren.",
  "pricing.faq.trial.question": "Kan ik eerst gratis starten en later een plan kiezen?",
  "pricing.faq.trial.answer": "Ja. Je kan eerst 14 dagen gratis testen en pas daarna beslissen welk plan het beste aansluit bij je portefeuille en werkwijze.",
  "pricing.faq.contact.question": "Waar stel ik vragen over abonnementen of een offerte op maat?",
  "pricing.faq.contact.answer": "Gebruik het helpcenter of het contactformulier om vragen over abonnementen, grotere portefeuilles of een oplossing op maat te bespreken.",
  "pages.home.title": "Beheer je vastgoed met gemak",
  "pages.pricing.title": "Prijzen",
  "pages.privacy.title": "Privacy Policy",
  "pages.privacy.description": "Lees hoe Ceustermans IT BV persoonsgegevens verwerkt voor Rentomax, welke rechten je hebt en hoe je contact opneemt over privacy.",
  "pages.terms.title": "Terms of Service",
  "pages.terms.description": "Lees de gebruiksvoorwaarden van Rentomax, inclusief accountregels, abonnementsvoorwaarden, opzegging, aansprakelijkheid en contactgegevens.",
  "pages.login.title": "Inloggen",
  "pages.dashboard.title": "Dashboard",
  "pages.calendar.title": "Kalender",
  "pages.properties.title": "Panden",
  "pages.damageReports.title": "Schademeldingen",
  "pages.propertyDetail.title": "Panddetails",
  "pages.tenants.title": "Huurders",
  "pages.documents.title": "Documenten",
  "pages.reminders.title": "Reminders",
  "pages.contractors.title": "Aannemers & leveranciers",
  "pages.waitinglist.title": "Kandidaten en wachtlijst",
  "tenantPage.title": "Huurders",
  "tenantPage.addButton": "Huurder toevoegen",
  "tenantPage.empty": "Nog geen huurders toegevoegd.",
  "tenantPage.addFirst": "Voeg eerste huurder toe",
  "tenantPage.timeline": "Tijdslijn",
  "tenantPage.loadError": "Fout bij het laden.",
  "tenantPage.confirmDelete": "Weet je zeker dat je deze huurder wilt verwijderen?",
  "tenantPage.personalInfo": "Persoonlijke gegevens",
  "tenantPage.noContact": "Geen contactgegevens",
  "tenantPage.agreementsTitle": "Huurovereenkomsten",
  "tenantPage.noAgreements": "Geen huurovereenkomsten.",
  "tenantPage.tabs.info": "Gegevens",
  "tenantPage.tabs.payments": "Betalingen",
  "tenantPage.tabs.timeline": "Tijdslijn",
  "tenantPage.tabs.documents": "Documenten",
  "tenantPage.tabs.placeDescriptions": "Plaatsbeschrijving",
  "tenantPage.tabs.dossier": "Dossier",
  "tenantPage.tabs.actions": "Acties",
  "tenantPage.tabs.welcomePage": "Welkomstpagina",
  "tenantPage.tabs.surveys": "Tevredenheid",
  "tenantPage.moreActions": "Meer acties",
  "tenantPage.portalSectionTitle": "Rentomax-account",
  "tenantPage.portalSectionDescription": "Koppel hier een bestaande Rentomax-account of verstuur de uitnodiging naar het e-mailadres van de huurder.",
  "tenantPage.portalActionsUnavailable": "Geen extra actie nodig",
  "tenantPage.portalLinkAction": "Rentomax-account koppelen",
  "tenantPage.portalLinkConfirm": "Wil je het bestaande Rentomax-account van {name} koppelen aan deze huurder?",
  "tenantPage.portalLinkSuccess": "{name} is nu gekoppeld aan Rentomax.",
  "tenantPage.portalLinkError": "De Rentomax-koppeling kon niet worden gelegd.",
  "tenantPage.portalLinkUnavailable": "Voor deze huurder kon geen koppelbaar Rentomax-account worden gevonden.",
  "tenantPage.portalInviteAction": "Rentomax-account uitnodigen",
  "tenantPage.portalInviteResendAction": "Rentomax-uitnodiging opnieuw versturen",
  "tenantPage.documentsTabDescription": "Beheer tenantdocumenten en upload nieuwe bestanden voor deze huurder.",
  "tenantPage.placeDescriptionsTabDescription": "Open de plaatsbeschrijvingen van deze huurder in een apart werkvenster.",
  "tenantPage.placeDescriptionsTabAction": "Plaatsbeschrijvingen openen",
  "tenantPage.dossierTabDescription": "Exporteer het tenantdossier met de onderdelen die je wilt meenemen.",
  "tenantPage.dossierTabAction": "Dossier exporteren",
  "tenantPage.portalInviteDialogTitle": "Nodig huurder uit voor Rentomax",
  "tenantPage.portalInviteDialogFreeNote": "In de e-mail maken we duidelijk dat een huurder-account op Rentomax gratis is en gratis blijft.",
  "tenantPage.portalInviteDialogMessageLabel": "Persoonlijk bericht voor in de e-mail",
  "tenantPage.portalInviteDialogMessagePlaceholder": "Voeg optioneel een korte persoonlijke boodschap toe.",
  "tenantPage.portalInviteSending": "Uitnodiging wordt verstuurd...",
  "tenantPage.portalInviteSuccess": "De uitnodiging werd verstuurd. Rechtstreekse link:",
  "tenantPage.portalInviteError": "De uitnodiging kon niet verstuurd worden.",
  "tenantPage.portalInviteUnavailable": "Voor deze huurder kan nu geen Rentomax-uitnodiging verstuurd worden.",
  "tenantPage.changeRent": "Huurprijs wijzigen",
  "tenantPage.noResults": "Geen huurders gevonden voor deze filters.",
  "tenantPage.filters.nameLabel": "Naam",
  "tenantPage.filters.namePlaceholder": "Zoek op naam",
  "tenantPage.filters.statusLabel": "Status",
  "tenantPage.filters.propertyLabel": "Pand",
  "tenantPage.filters.allStatuses": "Alle statussen",
  "tenantPage.filters.allProperties": "Alle panden",
  "tenantPage.filters.reset": "Filters wissen",
  "placeDescription.buttonShort": "Plaatsbeschrijving",
  "placeDescription.title": "Digitale plaatsbeschrijvingen",
  "placeDescription.drawerHelp": "Beheer intrede- en uittredeversies per huurder, met gestructureerde checklist en foto's per item.",
  "placeDescription.add": "Plaatsbeschrijving toevoegen",
  "placeDescription.loadError": "De plaatsbeschrijvingen konden niet worden geladen.",
  "placeDescription.empty": "Nog geen plaatsbeschrijvingen voor deze huurder.",
  "placeDescription.exportError": "De PDF kon niet worden gegenereerd.",
  "placeDescription.confirmDelete": "Weet je zeker dat je deze plaatsbeschrijving wilt verwijderen?",
  "placeDescription.confirmDeletePhoto": "Weet je zeker dat je deze foto wilt verwijderen?",
  "placeDescription.createUnavailable": "Maak eerst een huurovereenkomst aan voor je een plaatsbeschrijving toevoegt.",
  "placeDescription.templateLabel": "Checklist-template",
  "placeDescription.titlePlaceholder": "Bijvoorbeeld: Plaatsbeschrijving intrede",
  "placeDescription.notesPlaceholder": "Algemene opmerkingen over de staat, sleutels, meterstanden of afspraken...",
  "placeDescription.editorTitle": "Plaatsbeschrijving bewerken",
  "placeDescription.itemCommentPlaceholder": "Opmerking per checklist-item",
  "placeDescription.addPhoto": "Foto toevoegen",
  "placeDescription.noPhotos": "Nog geen foto's gekoppeld aan dit item.",
  "placeDescription.kind.moveIn": "Intrede",
  "placeDescription.kind.moveOut": "Uittrede",
  "placeDescription.condition.good": "Goed",
  "placeDescription.condition.needsAttention": "Aandachtspunt",
  "placeDescription.condition.damaged": "Beschadigd",
  "placeDescription.condition.notApplicable": "Niet van toepassing",
  "placeDescription.stats.sections": "secties",
  "placeDescription.stats.items": "items",
  "placeDescription.stats.photos": "foto's",
  "waitinglist.title": "Kandidaten en wachtlijst",
  "waitinglist.subtitle": "Pipeline per pand van kandidaat tot actieve huurder.",
  "waitinglist.addButton": "Kandidaat toevoegen",
  "waitinglist.addFirst": "Eerste kandidaat toevoegen",
  "waitinglist.noPropertiesTitle": "Geen panden gevonden",
  "waitinglist.noPropertiesBody": "Voeg eerst een pand toe voor je kandidaten beheert.",
  "waitinglist.emptyTitle": "Nog geen kandidaten voor dit pand",
  "waitinglist.emptyBody": "Voeg je eerste kandidaat-huurder toe aan de pipeline.",
  "waitinglist.pipelineCount": "{count} kandidaten in pipeline",
  "waitinglist.noCandidates": "Geen kandidaten",
  "waitinglist.expiredSection": "Verlopen ({count})",
  "waitinglist.expiredContract": "Contract verlopen",
  "waitinglist.reactivateTitle": "Zet terug als kandidaat",
  "waitinglist.reactivateButton": "Opnieuw kandidaat",
  "waitinglist.rejectButton": "Afwijzen",
  "waitinglist.interestDate": "Interesse",
  "waitinglist.confirmDelete": "Weet je zeker dat je deze kandidaat wilt verwijderen?",
  "waitinglist.loadError": "Fout bij het laden.",
  "waitinglist.status.candidate": "Kandidaat",
  "waitinglist.status.selected": "Geselecteerd",
  "waitinglist.status.rejected": "Afgewezen",
  "waitinglist.status.activeTenant": "Actieve huurder",
  "pages.contracts.title": "Contracten tijdslijn",
  "pages.profile.title": "Mijn profiel",
  "userMenu.profileHint": "Ga naar Mijn profiel",
  "userMenu.accountMode": "Accountmodus wisselen",
  "userMenu.accountModeTenantHint": "Huurder-mode actief. Open je profiel om over te schakelen.",
  "userMenu.accountModeLandlordHint": "Verhuurder-mode actief. Open je profiel om over te schakelen.",
  "userMenu.install": "Installeer app",
  "userMenu.installHint": "Plaats Rentomax op je laptop of smartphone",
  "pwa.installIosInstructions": "Open Deel en kies 'Zet op beginscherm' om Rentomax te installeren.",
  "pwa.installManualInstructions": "Open het browsermenu en kies 'App installeren' of 'Toevoegen aan beginscherm'.",
  "pwa.installed": "Rentomax is toegevoegd aan je toestel.",
  "pages.tenantActive.title": "Actieve huurovereenkomsten",
  "pages.tenantUpcoming.title": "Toekomstige huurovereenkomsten",
  "pages.tenantApplications.title": "Kandidaatstellingen",
  "pages.tenantHistory.title": "Afgelopen huurovereenkomsten",
  "pages.onboarding.title": "Welkom bij Rentomax",
  "pages.help.title": "Helpcenter",
  "pages.help.description": "Vind antwoorden op je vragen over Rentomax.",
  "help.hero.title": "Hoe kunnen we helpen?",
  "help.hero.subtitle": "Stel je vraag via het contactformulier hieronder.",
  "help.resources.title": "Sneller naar het juiste onderwerp binnen Rentomax",
  "help.resources.subtitle": "Gebruik deze ingangen als je vooral functies wilt verkennen, prijzen wilt vergelijken of meteen een supportvraag wilt stellen.",
  "help.resources.features.title": "Bekijk wat je in Rentomax beheert",
  "help.resources.features.body": "Ga terug naar de homepage voor een overzicht van pandbeheer, huurders, documenten, reminders, plaatsbeschrijvingen en exports.",
  "help.resources.features.button": "Naar de functies",
  "help.resources.pricing.title": "Vergelijk de prijsplannen",
  "help.resources.pricing.body": "Open de pricingpagina als je wilt weten welk plan past bij een eerste pand, meerdere panden of een grotere verhuurwerking.",
  "help.resources.pricing.button": "Bekijk de prijzen",
  "help.resources.contact.title": "Stel meteen een supportvraag",
  "help.resources.contact.body": "Ga rechtstreeks naar het contactformulier wanneer je hulp nodig hebt rond onboarding, dossiers, documenten of accountvragen.",
  "help.resources.contact.button": "Open het formulier",
  "help.faq.title": "Veelgestelde vragen",
  "help.faq.intro": "Kies een onderwerp en open alleen het antwoord dat je nodig hebt.",
  "help.faq.navLabel": "FAQ-categorieen",
  "help.faq.questionCount": "{count} vragen",
  "help.faq.categories.gettingStarted.title": "Starten met Rentomax",
  "help.faq.categories.gettingStarted.description": "De eerste stappen en een vlotte opstart.",
  "help.faq.categories.propertiesTenants.title": "Panden en huurders",
  "help.faq.categories.propertiesTenants.description": "Je dossiers, huurders en plaatsbeschrijvingen overzichtelijk houden.",
  "help.faq.categories.agreementsDocuments.title": "Contracten en documenten",
  "help.faq.categories.agreementsDocuments.description": "Wat je bewaart, opvolgt en exporteert per dossier.",
  "help.faq.categories.planningPayments.title": "Planning en opvolging",
  "help.faq.categories.planningPayments.description": "Reminders, kalender en manuele betalingsstatussen.",
  "help.faq.categories.dataSupport.title": "Werkwijze en support",
  "help.faq.categories.dataSupport.description": "Snelle tips voor nette data en gerichte hulp.",
  "help.faq.questions.setup.question": "Hoe begin ik best met Rentomax?",
  "help.faq.questions.setup.answer": "Begin met je profiel, voeg daarna je panden toe en kies per pand een duidelijke status. Voeg dan huurders, contracten en documenten toe.",
  "help.faq.questions.import.question": "Kan ik bestaande gegevens overnemen in plaats van alles opnieuw in te voeren?",
  "help.faq.questions.import.answer": "Ja. Gebruik onboarding en CSV-import om sneller te starten. Controleer nadien wel statussen, koppelingen en datums.",
  "help.faq.questions.overview.question": "Hoe houd ik mijn overzicht vanaf het begin bruikbaar?",
  "help.faq.questions.overview.answer": "Werk met vaste statussen, duidelijke namen en korte notities. Vul ook belangrijke datums en documenten meteen aan.",
  "help.faq.questions.countries.question": "Kan ik Rentomax gebruiken voor panden in verschillende landen?",
  "help.faq.questions.countries.answer": "Ja. Rentomax helpt je om verhuurdossiers in meerdere landen te organiseren. Het geeft geen juridisch advies over lokale regels.",
  "help.faq.questions.propertySetup.question": "Hoe richt ik een pand best in?",
  "help.faq.questions.propertySetup.answer": "Maak per pand een volledig dossier met adres, status, notities en documenten. Zo blijft filteren en opvolgen eenvoudig.",
  "help.faq.questions.buildingUnits.question": "Hoe werk ik met gebouwen en units in Rentomax?",
  "help.faq.questions.buildingUnits.answer": "Je kan een gebouw met meerdere units beheren, waarbij elke unit zijn eigen dossier houdt. Gedeelde gebouwinformatie en documenten blijven tegelijk centraal beschikbaar.",
  "help.faq.questions.tenantTracking.question": "Hoe beheer ik kandidaten en actieve huurders overzichtelijk?",
  "help.faq.questions.tenantTracking.answer": "Scheid kandidaten en actieve huurders via hun status en koppel ze aan het juiste pand. Vul contactgegevens en opvolgpunten meteen aan.",
  "help.faq.questions.welcomePage.question": "Waarvoor gebruik ik de welkomspagina voor een huurder?",
  "help.faq.questions.welcomePage.answer": "Gebruik die pagina om praktische info rond een huurder of opstartdossier samen te houden. Bijvoorbeeld afspraken, documenten en referenties.",
  "help.faq.questions.issueReporting.question": "Hoe volg ik schade- en issuemeldingen van huurders op?",
  "help.faq.questions.issueReporting.answer": "Actieve huurders kunnen problemen of schade registreren met foto's. Jij ziet die meldingen daarna per overeenkomst of pand in je opvolging.",
  "help.faq.questions.placeDescriptions.question": "Hoe gebruik ik plaatsbeschrijvingen, notities en foto's het best?",
  "help.faq.questions.placeDescriptions.answer": "Werk per ruimte of onderdeel met foto's en korte notities. Zo bouw je een duidelijk administratief dossier op.",
  "help.faq.questions.agreementInfo.question": "Welke informatie hoort thuis bij een huurovereenkomst in Rentomax?",
  "help.faq.questions.agreementInfo.answer": "Bewaar per overeenkomst de huurder, het pand, de looptijd, belangrijke datums en bijhorende documenten. Voeg reminders toe voor opvolging of vernieuwing.",
  "help.faq.questions.documentFollowUp.question": "Hoe volg ik documenten en vervaldata handig op?",
  "help.faq.questions.documentFollowUp.answer": "Koppel documenten meteen aan het juiste dossier en zet reminders op verval- of controledatums. Gebruik duidelijke namen zodat je snel terugvindt wat je zoekt.",
  "help.faq.questions.pdfDossier.question": "Wanneer is PDF-export nuttig?",
  "help.faq.questions.pdfDossier.answer": "PDF-export is handig om een dossier te delen of te archiveren. Werk je gegevens eerst bij voor een bruikbare momentopname.",
  "help.faq.questions.productBoundary.question": "Geeft Rentomax juridisch, fiscaal of compliance-advies?",
  "help.faq.questions.productBoundary.answer": "Nee. Rentomax is een administratieve tool voor overzicht en opvolging, niet voor juridisch of fiscaal advies.",
  "help.faq.questions.remindersEvents.question": "Wat is het verschil tussen reminders en events?",
  "help.faq.questions.remindersEvents.answer": "Gebruik reminders voor taken die je moet opvolgen. Gebruik events voor belangrijke datums of gebeurtenissen in je tijdslijn.",
  "help.faq.questions.manualPayments.question": "Hoe werkt de manuele opvolging van huurbetalingen?",
  "help.faq.questions.manualPayments.answer": "Je registreert betalingsstatussen manueel per dossier. Rentomax vervangt geen bankkoppeling of automatische afpunting.",
  "help.faq.questions.dashboardCalendar.question": "Hoe gebruik ik dashboard en kalender het meest efficiënt?",
  "help.faq.questions.dashboardCalendar.answer": "Gebruik je dashboard als dagelijks startpunt. Gebruik de kalender om komende deadlines en gebeurtenissen vooruit te plannen.",
  "help.faq.questions.recurringWorkflow.question": "Wat is een goede routine voor terugkerende opvolging?",
  "help.faq.questions.recurringWorkflow.answer": "Werk in korte vaste controles: documenten bijwerken, reminders zetten en statussen meteen aanpassen. Zo blijft je administratie actueel.",
  "help.faq.questions.dataQuality.question": "Hoe houd ik mijn data netjes en betrouwbaar?",
  "help.faq.questions.dataQuality.answer": "Werk met vaste namen, statussen en documenttitels. Vermijd dubbele dossiers en werk wijzigingen meteen bij.",
  "help.faq.questions.newOnboarding.question": "Hoe voeg ik een nieuw pand of nieuwe huurder snel toe zonder iets te vergeten?",
  "help.faq.questions.newOnboarding.answer": "Werk met een vaste checklist: basisgegevens, status, contactinfo, documenten, contract en reminders. Zo blijft elk nieuw dossier uniform.",
  "help.faq.questions.timelineUsage.question": "Waarom is de tijdslijn belangrijk in mijn dagelijkse werking?",
  "help.faq.questions.timelineUsage.answer": "De tijdslijn toont wat al gebeurd is in een dossier. Zo verlies je minder context bij latere opvolging.",
  "help.faq.questions.profileManagement.question": "Waar beheer ik mijn verhuurdersprofiel en accountinstellingen?",
  "help.faq.questions.profileManagement.answer": "Gebruik Mijn profiel om je profielgegevens, accountmodus en accounttoegang te beheren. Zo houd je je werkcontext en accountinstellingen op een vaste plek samen.",
  "help.faq.questions.helpContact.question": "Wat doe ik als ik toch geen antwoord vind in de FAQ?",
  "help.faq.questions.helpContact.answer": "Gebruik het contactformulier onderaan deze pagina. Vermeld kort over welk dossier of scherm je vraag gaat.",
  "help.contact.title": "Stuur ons een bericht",
  "help.success.title": "Bericht verzonden!",
  "help.success.body": "We nemen zo snel mogelijk contact met je op.",
  "help.success.reset": "Nog een bericht sturen",
  "help.form.name": "Naam",
  "help.form.namePlaceholder": "Jan Janssen",
  "help.form.emailPlaceholder": "jan@voorbeeld.be",
  "help.form.email": "E-mailadres",
  "help.form.subject": "Onderwerp",
  "help.form.subjectPlaceholder": "Waar gaat je vraag over?",
  "help.form.message": "Bericht",
  "help.form.messagePlaceholder": "Beschrijf je vraag of probleem...",
  "help.form.sending": "Bezig met verzenden...",
  "help.form.submit": "Verstuur bericht",
  "help.form.error": "Er is een fout opgetreden. Probeer het later opnieuw.",
  "help.form.networkError": "Kan geen verbinding maken. Controleer je internetverbinding.",
  "dashboard.activeTenants": "Actieve huurders",
  "dashboard.upcomingDeadlines": "Komende deadlines",
  "dashboard.propertyStatuses": "Panden per status",
  "dashboard.buildingOccupancy": "Bezetting per gebouw",
  "dashboard.buildingOccupancyMeta": "{occupied} van {total} units verhuurd",
  "dashboard.noUpcomingDeadlines": "Geen komende deadlines",
  "dashboard.recentEvents": "Recente events",
  "dashboard.noRecentEvents": "Geen recente events",
  "dashboard.viewAllReminders": "Alle reminders bekijken",
  "dashboard.viewTenants": "Huurders bekijken",
  "calendar.title": "Geïntegreerde kalender",
  "calendar.subtitle": "Alle komende datums uit reminders, documenten, contracten en events in één read-only overzicht.",
  "calendar.todayButton": "Vandaag",
  "calendar.viewDay": "Dag",
  "calendar.viewWeek": "Week",
  "calendar.filter.all": "Alles",
  "calendar.highlights.title": "Aandacht nodig",
  "calendar.highlights.subtitle": "De meest dringende items binnen deze periode.",
  "calendar.quickAction.property": "Open pand",
  "calendar.quickAction.tenant": "Open huurder",
  "calendar.loadError": "Fout bij het laden van de kalender",
  "calendar.empty": "Geen items in deze periode.",
  "calendar.summary.total": "Totaal",
  "calendar.summary.reminders": "Reminders",
  "calendar.summary.documents": "Documentverval",
  "calendar.summary.agreements": "Contracteindes",
  "calendar.summary.events": "Events",
  "calendar.source.reminder": "Reminder",
  "calendar.source.documentExpiry": "Document",
  "calendar.source.agreementEnd": "Contract",
  "calendar.source.timelineEvent": "Event",
  "calendar.item.agreementEndTitle": "Contract eindigt",
  "calendar.item.recurring": "Terugkerend",
  "property.loadError": "Fout bij het laden van panden.",
  "property.deleteError": "Het pand kon niet verwijderd worden.",
  "property.cardView": "Kaartweergave",
  "property.listView": "Lijstweergave",
  "property.add": "Pand toevoegen",
  "property.import": "CSV importeren",
  "property.importTitle": "Panden importeren via CSV",
  "property.importDescription": "Gebruik hetzelfde CSV-template om bestaande panden en huurders vanuit het platform in een keer over te zetten.",
  "property.importTemplateLink": "Download template.csv",
  "property.importFileLabel": "CSV-bestand",
  "property.importButton": "Import starten",
  "property.importHint": "We maken alleen de panden en huurders aan die binnen je huidige abonnementslimiet passen. Overschrijdt het bestand je limiet, dan stopt de import zonder iets aan te maken.",
  "property.importSuccess": "{propertyCount} panden en {tenantCount} huurders geimporteerd.",
  "property.importFileRequired": "Kies eerst het ingevulde CSV-bestand.",
  "property.importError": "De import is mislukt. Probeer opnieuw met het templatebestand.",
  "property.importRowError": "Rij {rowNumber} bevat ongeldige gegevens.",
  "property.addFirst": "Voeg je eerste pand toe",
  "property.empty": "Nog geen panden toegevoegd.",
  "property.rent": "Huurprijs",
  "property.perMonth": "/mnd",
  "property.tenantSingular": "huurder",
  "property.tenantPlural": "huurders",
  "property.unitSingular": "unit",
  "property.unitPlural": "units",
  "property.units.title": "Units",
  "property.documentSingular": "document",
  "property.documentPlural": "documenten",
  "property.status.rented": "Verhuurd",
  "property.status.vacant": "Leeg",
  "property.status.underRenovation": "In renovatie",
  "property.status.forSale": "Te koop",
  "property.type.apartment": "Appartement",
  "property.type.house": "Huis",
  "property.type.studio": "Studio",
  "property.type.commercial": "Commercieel",
  "property.type.garage": "Garage",
  "property.type.other": "Ander",
  "property.details.backToOverview": "Terug naar pandenoverzicht",
  "property.details.pageTitle": "Panddetails",
  "property.details.pageSubtitle": "Beheer huurders, documenten en opvolging van dit pand op een aparte pagina.",
  "property.details.missingSelection": "Kies eerst een pand in het overzicht.",
  "property.details.loadError": "Fout bij het laden van panddetails.",
  "property.rentHistory.title": "Huurhistoriek",
  "property.rentHistory.subtitle": "Chronologisch overzicht van de huurprijzen en contractperiodes die al voor dit pand zijn vastgelegd.",
  "property.rentHistory.empty": "Nog geen huurhistoriek beschikbaar voor dit pand.",
  "property.rentHistory.records": "registraties",
  "property.rentHistory.latestRent": "Laatste huurprijs",
  "property.rentHistory.ongoing": "lopende overeenkomst",
  "property.occupancy.title": "Bezettingsoverzicht",
  "property.occupancy.subtitle": "Visuele tijdslijn van verhuurde periodes, leegstand en huurderswissels op basis van bestaande contractdata.",
  "property.renewals.title": "Contractverlenging",
  "property.renewals.subtitle": "Volg aflopende contracten proactief op en registreer elke vervolgstap op de tijdslijn.",
  "property.renewals.empty": "Nog geen contracten met een actieve verlengingsopvolging voor dit pand.",
  "property.renewals.loadError": "Fout bij het laden van de contractverlengings-workflows.",
  "property.renewals.updateError": "Fout bij het bijwerken van de contractverlengings-workflow.",
  "property.renewals.endsOn": "Eindigt op",
  "property.renewals.stage.sixMonths": "Binnen 6 maanden",
  "property.renewals.stage.threeMonths": "Binnen 3 maanden",
  "property.renewals.step.extendAgreement": "Wil je verlengen? Pas de einddatum aan",
  "property.renewals.step.extendAgreementHint": "Werk de huurovereenkomst bij. Deze stap wordt automatisch voltooid zodra de einddatum verandert.",
  "property.renewals.step.contactTenant": "Wil je de huurder contacteren? Log een communicatie",
  "property.renewals.step.contactTenantHint": "Registreer dat je contact opnam over de contractverlenging.",
  "property.renewals.step.markUpcomingVacancy": "Wil je een nieuwe kandidaat zoeken? Markeer als binnenkort vrij",
  "property.renewals.step.markUpcomingVacancyHint": "Leg vast dat je dit pand binnenkort opnieuw in de markt wilt zetten.",
  "property.renewals.action.extendAgreement": "Einddatum aanpassen",
  "property.renewals.action.contactTenant": "Communicatie loggen",
  "property.renewals.action.markUpcomingVacancy": "Binnenkort vrij markeren",
  "property.renewals.contactModalTitle": "Communicatie registreren",
  "property.renewals.contactModalNote": "Notitie",
  "property.renewals.contactModalPlaceholder": "Bijvoorbeeld: huurder gecontacteerd over mogelijke verlenging.",
  "property.occupancy.empty": "Nog geen contracthistoriek beschikbaar voor dit pand.",
  "property.occupancy.contractCount": "contracten",
  "property.occupancy.currentlyOccupied": "Momenteel verhuurd",
  "property.occupancy.currentlyVacant": "Momenteel leeg",
  "property.occupancy.summary.rented": "Verhuurd",
  "property.occupancy.summary.vacant": "Leegstand",
  "property.occupancy.summary.averageLease": "Gemiddelde huurduur",
  "property.occupancy.summary.switches": "Huurderswissels",
  "property.occupancy.legend.occupied": "Verhuurd",
  "property.occupancy.legend.vacant": "Leegstand",
  "property.occupancy.legend.switch": "Wisselmoment",
  "property.occupancy.switchesTitle": "Huurderswissels",
  "property.occupancy.switchesSubtitle": "Overgangen tussen verschillende huurders op dit pand.",
  "property.occupancy.noSwitches": "Nog geen huurderswissels geregistreerd op basis van de bestaande contracten.",
  "property.occupancy.switchDirect": "Rechtstreekse wissel",
  "property.occupancy.switchAfterVacancy": "Na {{duration}} leegstand",
  "property.occupancy.vacancyLabel": "Leegstand",
  "property.occupancy.occupiedLabel": "Verhuurd",
  "property.occupancy.until": "tot",
  "property.occupancy.duration.none": "0 dagen",
  "property.occupancy.duration.days": "{{count}} dagen",
  "property.occupancy.duration.months": "{{count}} mnd",
  "property.occupancy.duration.monthsAndDays": "{{months}} mnd {{days}} dagen",
  "property.gallery.title": "Pandgalerij",
  "property.gallery.helper": "Gebruik deze foto's om je pand later in de kijker te zetten. Deze opslag telt mee voor je limiet.",
  "property.gallery.upload": "Foto's toevoegen",
  "property.gallery.empty": "Nog geen galerijfoto's voor dit pand.",
  "property.gallery.confirmDelete": "Wil je deze galerijfoto verwijderen?",
  "property.gallery.previewAlt": "Galerijfoto: {{fileName}}",
  "property.gallery.openPreview": "Open galerijfoto {{fileName}}",
  "property.gallery.lightboxTitle": "Galerijfoto vergroten",
  "property.gallery.closePreview": "Sluit fotovoorvertoning",
  "property.gallery.previous": "Vorige foto",
  "property.gallery.next": "Volgende foto",
  "property.gallery.position": "Foto {{current}} van {{total}}",
  "property.publicPage.tabTitle": "Publieke pagina",
  "property.publicPage.title": "Publieke pandlink",
  "property.publicPage.helper": "Maak voor dit pand een publieke pagina die je kunt delen met kandidaat-huurders. De link toont adres, type, beschrijving en foto's uit de galerij.",
  "property.publicPage.status.notConfigured": "Nog niet ingesteld",
  "property.publicPage.status.inactive": "Link gedeactiveerd",
  "property.publicPage.status.active": "Link actief",
  "property.publicPage.status.expired": "Link vervallen",
  "property.publicPage.publicLink": "Publieke link",
  "property.publicPage.linkUnavailable": "Sla de instellingen eerst op om een publieke link te genereren.",
  "property.publicPage.isActiveLabel": "Publieke link bereikbaar maken",
  "property.publicPage.isActiveHint": "Bezoekers zonder account kunnen deze pagina openen zolang de link actief is.",
  "property.publicPage.expiresAt": "Bereikbaar tot",
  "property.publicPage.expiresAtHint": "Optioneel. Laat leeg als de link altijd bereikbaar mag blijven.",
  "property.publicPage.alwaysAvailable": "Altijd bereikbaar",
  "property.publicPage.save": "Instellingen opslaan",
  "property.publicPage.saved": "Publieke pandlink opgeslagen.",
  "property.publicPage.copySuccess": "Publieke link gekopieerd.",
  "property.publicPage.copyError": "Publieke link kopieren mislukt.",
  "property.publicPage.clearExpiry": "Leegmaken",
  "property.publicPage.updatedAt": "Laatste update",
  "property.publicPage.previewTitle": "Wat bezoekers te zien krijgen",
  "property.publicPage.previewDescription": "De publieke pagina gebruikt de basisinfo van het pand en de foto's uit je galerij.",
  "property.publicPage.previewAddress": "Adres",
  "property.publicPage.previewType": "Type",
  "property.publicPage.previewStatus": "Status",
  "property.publicPage.previewPhotos": "Galerijfoto's",
  "property.publicPage.previewNoDescription": "Voeg een beschrijving toe aan het pand om extra context te tonen op de publieke pagina.",
  "property.publicPage.loadError": "De publieke pandinstellingen konden niet geladen worden.",
  "property.radar.title": "Vervaldatumradar",
  "property.radar.subtitle": "Visueel overzicht van documenten, contracten en open reminders in de komende 12 maanden.",
  "property.radar.empty": "Geen vervaldatums of open reminders gevonden in de komende 12 maanden.",
  "property.radar.contractEnds": "Contract eindigt",
  "property.radar.upcoming": "Later",
  "property.radar.urgent": "Urgent nu",
  "property.radar.noUrgent": "Geen urgente vervaldatums in de komende 30 dagen.",
  "property.radar.timeline": "12 maanden",
  "property.radar.moreItems": "extra items",
  "property.turnovers.title": "Bewonerswissel",
  "property.turnovers.subtitle": "Volg uittrede en intrede stap voor stap op en leg elke afgewerkte stap vast op de tijdslijn.",
  "property.turnovers.addButton": "Checklist starten",
  "property.turnovers.empty": "Nog geen bewonerswissel-checklists voor dit pand.",
  "property.turnovers.loadError": "Fout bij het laden van de bewonerswissel-checklists.",
  "property.turnovers.createError": "Fout bij het aanmaken van de bewonerswissel-checklist.",
  "property.turnovers.updateError": "Fout bij het bijwerken van de bewonerswissel-checklist.",
  "property.turnovers.deleteError": "Fout bij het verwijderen van de bewonerswissel-checklist.",
  "property.turnovers.confirmDelete": "Weet je zeker dat je deze bewonerswissel-checklist wilt verwijderen?",
  "property.turnovers.createTitle": "Bewonerswissel starten",
  "property.turnovers.titlePlaceholder": "Bijvoorbeeld: Wissel appartement 2A",
  "property.turnovers.completedShort": "afgewerkt",
  "property.turnovers.completedAt": "Afgevinkt op",
  "property.turnovers.exitPhase": "Uittrede",
  "property.turnovers.entryPhase": "Intrede",
  "property.turnovers.exitHelp": "Taken voor de vertrekkende huurder.",
  "property.turnovers.entryHelp": "Taken voor de nieuwe huurder.",
  "property.turnovers.exitMissingAgreement": "Koppel eerst een vertrekkende huurder om uittredestappen af te vinken.",
  "property.turnovers.entryMissingAgreement": "Koppel eerst een nieuwe huurder om intredestappen af te vinken.",
  "property.turnovers.outgoingTenantLabel": "Vertrekkende huurder",
  "property.turnovers.incomingTenantLabel": "Nieuwe huurder",
  "property.turnovers.noOutgoingTenant": "Nog niet gekoppeld",
  "property.turnovers.noIncomingTenant": "Nog niet gekoppeld",
  "property.turnovers.openPlaceDescription": "Plaatsbeschrijving openen",
  "property.turnovers.step.exitKeysReturned": "Sleutels teruggegeven",
  "property.turnovers.step.exitMeterReadingsRecorded": "Eindstand meters genoteerd",
  "property.turnovers.step.exitPlaceDescriptionCompleted": "Plaatsbeschrijving uittrede gemaakt",
  "property.turnovers.step.exitDepositStatusRecorded": "Borg-status genoteerd",
  "property.turnovers.step.exitDomicileHandled": "Domiciliëring afgehandeld",
  "property.turnovers.step.entryKeysHandedOver": "Sleutels overhandigd",
  "property.turnovers.step.entryMeterReadingsRecorded": "Beginstand meters genoteerd",
  "property.turnovers.step.entryPlaceDescriptionCompleted": "Plaatsbeschrijving intrede gemaakt",
  "property.turnovers.step.entryDepositStatusRecorded": "Borg-status genoteerd",
  "property.turnovers.step.entryHouseRulesShared": "Huurder op de hoogte van huisregels",
  "timeline.turnover.exitKeysReturned": "Bewonerswissel: sleutels teruggegeven",
  "timeline.turnover.exitMeterReadingsRecorded": "Bewonerswissel: eindstand meters genoteerd",
  "timeline.turnover.exitPlaceDescriptionCompleted": "Bewonerswissel: plaatsbeschrijving uittrede gemaakt",
  "timeline.turnover.exitDepositStatusRecorded": "Bewonerswissel: borg-status uittrede genoteerd",
  "timeline.turnover.exitDomicileHandled": "Bewonerswissel: domiciliëring afgehandeld",
  "timeline.turnover.entryKeysHandedOver": "Bewonerswissel: sleutels overhandigd",
  "timeline.turnover.entryMeterReadingsRecorded": "Bewonerswissel: beginstand meters genoteerd",
  "timeline.turnover.entryPlaceDescriptionCompleted": "Bewonerswissel: plaatsbeschrijving intrede gemaakt",
  "timeline.turnover.entryDepositStatusRecorded": "Bewonerswissel: borg-status intrede genoteerd",
  "timeline.turnover.entryHouseRulesShared": "Bewonerswissel: huurder op de hoogte van huisregels",
  "timeline.contractRenewal.extendAgreementCompleted": "Contractverlenging: einddatum aangepast",
  "timeline.contractRenewal.contactTenantLogged": "Contractverlenging: communicatie met huurder gelogd",
  "timeline.contractRenewal.upcomingVacancyMarked": "Contractverlenging: pand gemarkeerd als binnenkort vrij",
  "document.upload": "Document uploaden",
  "document.type.inspection": "Keuring",
  "document.type.insurance": "Verzekering",
  "document.type.invoice": "Factuur",
  "document.type.photo": "Foto",
  "document.type.other": "Overig",
  "document.title": "Documenten",
  "document.loadError": "Fout bij het laden.",
  "document.all": "Alle",
  "document.empty": "Nog geen documenten geupload.",
  "document.emptyFiltered": "Geen documenten van type \"{type}\".",
  "document.uploadFirst": "Upload eerste document",
  "document.linkProperty": "Koppel aan pand",
  "document.linkTenant": "Koppel aan huurder",
  "document.tagsPlaceholder": "bv. keuring, jaarlijks",
  "document.confirmDelete": "Weet je zeker dat je dit document wilt verwijderen?",
  "document.expired": "Verlopen",
  "document.expiringSoon": "Binnenkort",
  "document.share": "Delen",
  "document.shareTitle": "Documentlink delen",
  "document.shareLink": "Publieke link",
  "document.shareExpires": "Deze link blijft geldig tot {date}.",
  "document.shareCopied": "Link gekopieerd.",
  "document.shareError": "Link kon niet aangemaakt worden.",
  "document.uploadError": "Het document kon niet geüpload worden.",
  "document.storageTitle": "Opslagruimte",
  "document.storageHelp": "Je document- en foto-opslag volgt de limiet van je huidige abonnement.",
  "document.storageLimitExceeded": "Je opslaglimiet is bereikt. Upgrade je abonnement om meer bestanden te uploaden.",
  "document.storageUpgradeButton": "Bekijk upgrade-opties",
  "document.storageSelectionTooLarge": "Dit bestand is ongeveer {fileSize} groot, maar je hebt nog maar {remaining} opslagruimte over.",
  "reminder.add": "Reminder toevoegen",
  "reminder.title": "Reminders",
  "reminder.loadError": "Fout bij het laden.",
  "reminder.overdueAlert": "{count} verlopen reminder{suffix} - actie vereist.",
  "reminder.emptyOpen": "Geen openstaande reminders.",
  "reminder.emptyCompleted": "Geen voltooide reminders.",
  "reminder.emptyAll": "Nog geen reminders aangemaakt.",
  "reminder.complete": "Voltooien",
  "reminder.new": "Nieuwe reminder",
  "reminder.linkProperty": "Koppel aan pand",
  "reminder.titlePlaceholder": "bv. EPC laten vernieuwen",
  "reminder.confirmDelete": "Weet je zeker dat je deze reminder wilt verwijderen?",
  "reminder.recurrence": "Herhaling",
  "reminder.noRecurrence": "Eenmalig",
  "reminder.recurring": "Terugkerend",
  "reminder.recurrenceHint": "Laat het aantal leeg voor een eenmalige reminder.",
  "reminder.recurrenceSummaryOneTime": "Deze reminder wordt eenmalig aangemaakt.",
  "reminder.recurrenceSummaryValue": "Deze reminder herhaalt: {recurrence}.",
  "reminder.recurrenceDateSummaryMissingDeadline": "Kies een deadline om de geplande datum te zien.",
  "reminder.recurrenceDateSummaryOneTime": "Deze reminder vindt plaats op: {date}.",
  "reminder.recurrenceDateSummaryRecurring": "De volgende reminder na deze deadline is op: {date}.",
  "reminder.recurrenceValueLabel": "Elke",
  "reminder.recurrenceValuePlaceholder": "Aantal",
  "reminder.recurrenceUnit": "Type herhaling",
  "reminder.recurrenceUnitDaySingle": "dag",
  "reminder.recurrenceUnitDay": "dagen",
  "reminder.recurrenceUnitMonthSingle": "maand",
  "reminder.recurrenceUnitMonth": "maanden",
  "reminder.recurrenceUnitYearSingle": "jaar",
  "reminder.recurrenceUnitYear": "jaren",
  "reminder.recurrenceEveryDay": "Elke dag",
  "reminder.recurrenceEveryMonth": "Elke maand",
  "reminder.recurrenceEveryYear": "Elk jaar",
  "reminder.recurrenceEveryNDays": "Elke {count} dagen",
  "reminder.recurrenceEveryNMonths": "Elke {count} maanden",
  "reminder.recurrenceEveryNYears": "Elke {count} jaar",
  "contractor.title": "Aannemers & leveranciers",
  "contractor.subtitle": "Bewaar vaste contactpersonen voor onderhoud, herstellingen, plaatsbezoeken en praktische opvolging.",
  "contractor.add": "Aannemer toevoegen",
  "contractor.new": "Nieuwe aannemer",
  "contractor.edit": "Aannemer bewerken",
  "contractor.empty": "Nog geen aannemers of leveranciers toegevoegd.",
  "contractor.emptyFiltered": "Geen aannemers gevonden voor deze filters.",
  "contractor.loadError": "Fout bij het laden van aannemers.",
  "contractor.confirmDelete": "Weet je zeker dat je deze aannemer wilt verwijderen?",
  "contractor.deleteError": "De aannemer kon niet verwijderd worden.",
  "contractor.trade": "Vak / dienst",
  "contractor.filter.searchLabel": "Zoeken",
  "contractor.filter.searchPlaceholder": "Zoek op naam, vak, notitie, e-mail of telefoon",
  "contractor.filter.tradeLabel": "Vak",
  "contractor.filter.allTrades": "Alle vakken",
  "contractor.stats.total": "Contacten",
  "contractor.stats.email": "Met e-mail",
  "contractor.stats.phone": "Met telefoon",
  "contractor.namePlaceholder": "bv. Jan Vermeersch",
  "contractor.tradePlaceholder": "bv. Loodgieter, elektricien, …",
  "contractor.phoneNumberPlaceholder": "bv. 0475 12 34 56",
  "contractor.emailPlaceholder": "bv. info@bedrijf.be",
  "contractor.notesPlaceholder": "bv. Snel beschikbaar, goede prijs",
  "profile.notLoggedIn": "Je bent niet ingelogd.",
  "profile.paymentMethods": "Betaalmiddelen",
  "profile.invoices": "Facturen",
  "profile.paymentMethodsSoon": "Betaalmiddelen komen binnenkort beschikbaar.",
  "profile.invoicesSoon": "Facturen komen binnenkort beschikbaar.",
  "profile.loading": "Profiel laden...",
  "profile.name": "Naam",
  "profile.providerName": "Naam van je inlogprovider",
  "profile.displayNameTitle": "Weergavenaam",
  "profile.displayNameHelp": "Gebruik je voornaam en naam.",
  "profile.customDisplayName": "Naam",
  "profile.loginProvider": "Inloggen via",
  "profile.addressDetails": "Adresgegevens",
  "profile.addressHelp": "Deze gegevens worden gebruikt voor je verhuurdersprofiel.",
  "profile.accountType": "Accounttype",
  "profile.accountType.private": "Particulier",
  "profile.accountType.business": "Zakelijk",
  "profile.companyName": "Bedrijfsnaam",
  "profile.vatNumber": "Btw-nummer",
  "profile.street": "Straat",
  "profile.houseNumber": "Huisnummer",
  "profile.postalCode": "Postcode",
  "profile.city": "Stad",
  "profile.country": "Land",
  "profile.countryPlaceholder": "Kies een EU-land",
  "profile.billingAddress": "Facturatie-adres",
  "profile.billingHelp": "Optioneel. Vul dit alleen in als je facturatie-adres verschilt van je gewone adres.",
  "profile.saveButton": "Profiel opslaan",
  "profile.saved": "Profiel opgeslagen.",
  "profile.loadError": "Profiel kon niet geladen worden.",
  "profile.saveError": "Profiel kon niet opgeslagen worden.",
  "onboarding.displayNameHelp": "Gebruik je voornaam en naam om je account in te stellen.",
  "onboarding.csvTitle": "Bestaande panden importeren",
  "onboarding.csvDescription": "Gebruik het CSV-template om bestaande panden en huurders in een keer over te zetten. Elke rij bevat een naam, adres, huurprijs en startdatum.",
  "onboarding.csvTemplateLink": "Download template.csv",
  "onboarding.csvFileLabel": "CSV kiezen",
  "onboarding.csvImportButton": "CSV importeren",
  "onboarding.csvHint": "Na een succesvolle import slaan we de manuele pand- en huurderstap over en ga je meteen verder in de onboarding.",
  "billing.loading": "Abonnementsgegevens laden...",
  "billing.subscriptionTab": "Abonnement",
  "billing.invoicesTab": "Facturen",
  "billing.checkoutSuccess": "Je abonnement werd succesvol geactiveerd.",
  "billing.checkoutProcessing": "Je betaling is ontvangen en wordt nog verwerkt.",
  "billing.processingEyebrow": "Betaling in verwerking",
  "billing.processingTitle": "We werken je abonnement bij",
  "billing.processingBody": "Je betaling is gelukt. Rentomax wacht nog even tot de betalingsverwerking en synchronisatie volledig zijn afgerond.",
  "billing.processingHint": "Deze pagina wordt automatisch vernieuwd zodra je abonnement actief is of je wijziging verwerkt werd.",
  "billing.checkoutCancelled": "Checkout werd geannuleerd.",
  "billing.checkoutError": "Checkout kon niet gestart worden.",
  "billing.resumeCheckoutTitle": "Abonnement voorbereiden",
  "billing.resumeCheckoutBody": "Even geduld. We brengen je meteen naar je abonnement of naar de checkout.",
  "billing.portalError": "Het klantenportaal kon niet geopend worden.",
  "billing.portalLoading": "Portaal openen...",
  "billing.noSubscription": "Je hebt momenteel nog geen actief abonnement.",
  "billing.noSubscriptionTitle": "Geen actief abonnement",
  "billing.choosePlan": "Kies een abonnement",
  "billing.choosePlanHelp": "Selecteer een plan en facturatieperiode om verder te gaan.",
  "billing.currentPlan": "Huidig abonnement",
  "billing.currentTrialPlan": "Trial",
  "billing.manageHelp": "Annuleren, upgraden, downgraden en betaalgegevens beheren verloopt via het klantenportaal van de betaalprovider.",
  "billing.manageInAppHelp": "Annuleren, upgraden en downgraden beheer je hier rechtstreeks in Rentomax.",
  "billing.planLabel": "Plan",
  "billing.intervalLabel": "Facturatie",
  "billing.statusLabel": "Status",
  "billing.adminTitle": "Administrator-toegang",
  "billing.adminBody": "Je account heeft administratorrechten. Voor deze rol is geen abonnement vereist.",
  "billing.adminBadge": "Geen abonnement vereist",
  "billing.trialTitle": "Gratis proefperiode",
  "billing.trialBody": "Je gebruikt Rentomax tijdelijk met dezelfde limieten als het Starter-abonnement.",
  "billing.trialChoosePlanHelp": "Je trial loopt nog. Kies alvast een abonnement om Rentomax na de proefperiode verder te gebruiken.",
  "billing.trialStartedOn": "Gestart op",
  "billing.trialEndsOn": "Eindigt op",
  "billing.trialDayRemaining": "dag resterend",
  "billing.trialDaysRemaining": "{count} dagen resterend",
  "billing.propertyLimitSingular": "1 pand",
  "billing.propertyLimitPlural": "{count} panden",
  "billing.storageUsed": "Gebruikt",
  "billing.storageAvailable": "Opslaglimiet",
  "billing.storageRemaining": "Resterend",
  "billing.storagePlanFeature": "{storage} opslag, goed voor ongeveer {count} documenten of foto's",
  "billing.renewsOn": "Volgende vernieuwing",
  "billing.endsOn": "Eindigt op",
  "billing.creditBalance": "Tegoed",
  "billing.cancelScheduled": "Je abonnement werd ingepland om te stoppen op het einde van de huidige periode.",
  "billing.manageSubscription": "Beheer abonnement",
  "billing.changePlan": "Abonnement wijzigen",
  "billing.changePlanHelp": "Upgrades gaan meteen in na betaling. Downgrades worden op de volgende betaalperiode ingepland.",
  "billing.changeTerms.title": "Wijzigingen aan je abonnement",
  "billing.changeTerms.linkLabel": "Klik hier om de voorwaarden bij wijziging te lezen",
  "billing.changeTerms.consentLabel": "Ik heb de voorwaarden bij wijziging gelezen en ga hiermee akkoord voordat ik mijn abonnement wijzig.",
  "consent.eyebrow": "Privacy",
  "consent.title": "Kies hoe Rentomax opslag op dit toestel gebruikt",
  "consent.description": "Rentomax gebruikt cookies en lokale opslag voor taalkeuze, sessiebeveiliging en een vlotte ervaring op publieke en ingelogde pagina's.",
  "consent.actions.necessary": "Alleen noodzakelijk",
  "consent.actions.all": "Alles accepteren",
  "consent.saved.pending": "Je keuze wordt op dit toestel bewaard zodra je een optie kiest.",
  "consent.saved.necessary": "Je keuze voor alleen noodzakelijke opslag is op dit toestel bewaard.",
  "consent.saved.all": "Je keuze om alle opslag toe te staan is op dit toestel bewaard.",
  "billing.changeTerms.validationError": "Bevestig eerst dat je de voorwaarden bij wijziging hebt gelezen voordat je een abonnement kiest.",
  "billing.changeTerms.intro": "Wanneer je je abonnement wijzigt, gelden de onderstaande verrekenregels voor de resterende betaalde periode.",
  "billing.changeTerms.downgrade": "Een downgrade naar een lager abonnement of een lagere formule gaat in op het einde van je huidige betaalde facturatieperiode. Je huidige abonnement blijft actief tot dan en reeds betaalde bedragen worden niet tussentijds terugbetaald.",
  "billing.changeTerms.upgrade": "Een upgrade naar een hoger abonnement of een andere formule gaat onmiddellijk in. Het resterende saldo van je huidige periode wordt pro rata als krediet verrekend met komende betalingen.",
  "billing.cancelSubscription": "Abonnement annuleren",
  "billing.cancelConfirm": "Weet je zeker dat je je abonnement wil annuleren?",
  "billing.coolingOffTrialStartedTitle": "Je gratis proefperiode is gestart",
  "billing.coolingOffTrialStartedBody": "Je abonnement werd geannuleerd en je schakelt nu over naar een gratis proefperiode van 14 dagen.",
  "billing.coolingOffProfileOnlyTitle": "Je abonnement werd geannuleerd",
  "billing.coolingOffProfileOnlyBody": "Je abonnement werd geannuleerd. Je hebt geen gratis proefperiode meer beschikbaar en hebt nu alleen nog toegang tot deze profielpagina.",
  "billing.subscriptionUpdated": "Je abonnementswijziging werd verwerkt.",
  "billing.subscriptionUpdatedImmediate": "Je abonnement werd meteen bijgewerkt.",
  "billing.subscriptionUpdatedScheduled": "Je abonnementswijziging werd ingepland voor de volgende betaalperiode.",
  "billing.subscriptionUpdateError": "Je abonnement kon niet worden gewijzigd.",
  "billing.subscriptionCancelled": "Je abonnement werd geannuleerd.",
  "billing.subscriptionCancelError": "Je abonnement kon niet worden geannuleerd.",
  "billing.subscriptionActionLoading": "Bezig...",
  "billing.currentSelection": "Huidige keuze",
  "billing.pendingChangeTitle": "Geplande wijziging",
  "billing.pendingChangeBody": "Je abonnement wijzigt naar {plan} ({interval}) op {date}.",
  "billing.pendingChangeBodyAfterPayment": "Je abonnement wijzigt naar {plan} ({interval}) zodra je betaling bevestigd is.",
  "billing.comparePlans": "Vergelijk plannen",
  "billing.invoiceHistory": "Factuurhistoriek",
  "billing.invoiceHelp": "Open je facturen hier zodra ze beschikbaar zijn.",
  "billing.noInvoices": "Er zijn nog geen facturen beschikbaar.",
  "billing.invoiceLabel": "Factuur",
  "billing.creditNoteLabel": "Creditnota",
  "billing.invoiceFallbackTitle": "Factuur",
  "billing.viewInvoice": "Bekijk factuur",
  "billing.manageExistingSubscription": "Je hebt al een actief abonnement. Beheer upgrades en downgrades via je profielpagina.",
  "billing.status.active": "Actief",
  "billing.status.trialing": "Proefperiode",
  "billing.status.pastDue": "Openstaand",
  "billing.status.canceled": "Geannuleerd",
  "billing.status.unpaid": "Onbetaald",
  "billing.status.incomplete": "Onvolledig",
  "billing.status.incompleteExpired": "Verlopen",
  "billing.status.pending": "In verwerking",
  "billing.status.failed": "Mislukt",
  "billing.status.expired": "Verlopen",
  "billing.status.paid": "Betaald",
  "billing.status.open": "Open",
  "billing.status.draft": "Concept",
  "billing.status.void": "Geannuleerd",
  "trialNotice.title": "Je gratis proefperiode is gestart",
  "trialNotice.subtitle": "Je gebruikt Rentomax nu 14 dagen gratis.",
  "trialNotice.body": "Tijdens je proefperiode heb je dezelfde mogelijkheden als het Starter-abonnement. Je kunt later vanuit je profiel een abonnement kiezen.",
  "trialNotice.confirm": "Begrepen",
  "property.limit.title": "Je hebt de limiet van je abonnement bereikt",
  "property.limit.error": "Je abonnement laat geen extra panden toe.",
  "property.limit.description.single": "Je huidige abonnement laat maximaal {count} pand toe.",
  "property.limit.description.multi": "Je huidige abonnement laat maximaal {count} panden toe.",
  "property.limit.description.singleWithPlan": "Je huidige abonnement laat maximaal {count} pand toe. Upgrade naar {plan} om meer panden toe te voegen.",
  "property.limit.description.multiWithPlan": "Je huidige abonnement laat maximaal {count} panden toe. Upgrade naar {plan} om meer panden toe te voegen.",
  "property.limit.upgradeButton": "Bekijk upgrade-opties",
  "event.moveIn": "Intrede",
  "event.moveOut": "Uittrede",
  "event.damage": "Schade",
  "event.inspection": "Inspectie",
  "event.indexation": "Indexatie",
  "event.propertyStatusChange": "Pandstatus",
  "event.remark": "Opmerking",
  "confirm.title": "Bevestiging",
  "timeline.add": "Event toevoegen",
  "timeline.empty": "Nog geen events geregistreerd.",
  "timeline.newEvent": "Nieuw event",
  "timeline.titlePlaceholder": "Beschrijf het event kort",
  "timeline.descriptionPlaceholder": "Optionele aanvullende details...",
  "timeline.saving": "Bezig...",
  "timeline.loadError": "Fout bij het laden van de tijdslijn.",
  "tenantPayments.sectionTitle": "Huurbetalingen",
  "tenantPayments.empty": "Nog geen huurovereenkomsten met betaalmaanden beschikbaar.",
  "tenantPayments.unavailable": "Fout bij het laden van het betaallogboek.",
  "tenantPayments.modalTitle": "Huurbetaling opvolgen",
  "tenantPayments.statusLabel": "Status",
  "tenantPayments.clearStatus": "Niet ingevuld",
  "tenantPayments.paidOn": "Betaald op",
  "tenantPayments.note": "Opmerking",
  "tenantPayments.notePlaceholder": "Bijvoorbeeld: 3 dagen te laat of gedeeltelijk betaald",
  "tenantPayments.saveError": "Opslaan van de huurbetaling is mislukt.",
  "tenantPayments.status.paid": "Betaald",
  "tenantPayments.status.unpaid": "Niet betaald",
  "tenantPayments.status.unmarked": "Open",
  "dossier.buttonShort": "Dossier",
  "dossier.property.modalTitle": "Verhuurdersdossier exporteren",
  "dossier.property.modalDescription": "Kies welke onderdelen in de PDF-bundel van dit pand moeten komen.",
  "dossier.property.section.summary": "Pandoverzicht",
  "dossier.property.section.tenants": "Huurders en contactgegevens",
  "dossier.property.section.documents": "Documentenoverzicht",
  "dossier.property.section.reminders": "Reminders",
  "dossier.tenant.modalTitle": "Huurdersdossier exporteren",
  "dossier.tenant.modalDescription": "Kies welke onderdelen in de PDF-bundel van deze huurder moeten komen.",
  "dossier.tenant.section.contact": "Contactgegevens",
  "dossier.tenant.section.agreements": "Huurovereenkomsten",
  "dossier.tenant.section.documents": "Documenten",
  "dossier.tenant.section.timeline": "Tijdslijn",
  "dossier.tenant.section.reminders": "Gerelateerde reminders",
  "dossier.error.emptySelection": "Selecteer minstens een onderdeel voor de export.",
  "dossier.error.exportFailed": "De PDF kon niet worden gegenereerd.",
  "nav.admin": "Admin",
  "pages.admin.title": "Admin",
  "pages.admin.description": "Beheer gebruikers en applicatiefouten in Rentomax.",
  "admin.loadError": "Fout bij het laden van gebruikers.",
  "admin.accessDenied": "Geen toegang. Adminrechten vereist.",
  "admin.subtitle": "Beheer gebruikers en bekijk gelogde application errors.",
  "admin.tab.users": "Gebruikers",
  "admin.tab.plans": "Abonnementen",
  "admin.tab.invoices": "Facturen",
  "admin.tab.creditNotes": "Creditnota's",
  "admin.tab.revenue": "Omzet",
  "admin.tab.errors": "Fouten",
  "admin.billingPlans.title": "Abonnementen beheren",
  "admin.billingPlans.subtitle": "Pas per abonnement de prijs, property-limiet en storage-limiet aan. Nieuwe abonnementen toevoegen of verwijderen is hier niet mogelijk.",
  "admin.billingPlans.monthlyPrice": "Maandprijs (EUR)",
  "admin.billingPlans.yearlyPrice": "Jaarprijs (EUR)",
  "admin.billingPlans.priceExcludingVat": "excl. 21% btw: {amount}",
  "admin.billingPlans.propertyLimit": "Property-limiet",
  "admin.billingPlans.storageLimitGb": "Storage-limiet (GB)",
  "admin.billingPlans.save": "Opslaan",
  "admin.billingPlans.loadError": "De abonnementenconfiguratie kon niet geladen worden.",
  "admin.billingPlans.saveError": "De abonnementenconfiguratie kon niet opgeslagen worden.",
  "admin.platformReset.openButton": "Platform resetten",
  "admin.platformReset.dialogTitle": "Platform resetten",
  "admin.platformReset.dialogSubtitle": "Verwijder alle platformdata behalve het account van admin@rentomax.be en alle gekoppelde gegevens van dat account.",
  "admin.platformReset.warningTitle": "Let op: deze reset zet het platform terug naar een clean state.",
  "admin.platformReset.warningIntro": "Na bevestiging worden alle andere gebruikers, panden, huurders, abonnementen, facturen, logs en gekoppelde storagebestanden definitief verwijderd.",
  "admin.platformReset.consequenceData": "Alle databasegegevens van andere accounts worden verwijderd uit alle gekoppelde tabellen.",
  "admin.platformReset.consequenceFiles": "Alle gekoppelde documenten, foto's, facturen en creditnota's in storage worden mee verwijderd.",
  "admin.platformReset.consequencePreserved": "Alleen admin@rentomax.be en alle gekoppelde data van dat account blijven behouden.",
  "admin.platformReset.consequenceIrreversible": "Na bevestiging kan deze reset niet meer ongedaan gemaakt worden.",
  "admin.platformReset.confirmationLabel": "Typ rentomax om te bevestigen",
  "admin.platformReset.confirmationPlaceholder": "rentomax",
  "admin.platformReset.confirmationHelp": "De bevestigknop wordt pas actief wanneer je exact rentomax invult.",
  "admin.platformReset.confirmationMismatch": "Typ exact rentomax om de reset te bevestigen.",
  "admin.platformReset.confirmLabel": "Platform resetten",
  "admin.platformReset.resetError": "Het platform kon niet gereset worden.",
  "admin.newUserAccess.sectionTitle": "Toegang voor nieuwe gebruikers",
  "admin.newUserAccess.sectionDescription": "Bepaal of nieuwe accounts zich nog mogen aanmelden. Bestaande accounts behouden toegang.",
  "admin.newUserAccess.enabled": "Nieuwe gebruikers toegelaten",
  "admin.newUserAccess.disabled": "Nieuwe gebruikers geblokkeerd",
  "admin.newUserAccess.toggleLabel": "Aan/uit",
  "admin.newUserAccess.saveError": "De toegang voor nieuwe gebruikers kon niet opgeslagen worden.",
  "admin.googleLogin.sectionTitle": "Google-login",
  "admin.googleLogin.sectionDescription": "Bepaal of bezoekers nog mogen inloggen of een account aanmaken via Google. De knop op de loginpagina volgt deze instelling meteen.",
  "admin.googleLogin.enabled": "Google-login actief",
  "admin.googleLogin.disabled": "Google-login uitgeschakeld",
  "admin.googleLogin.toggleLabel": "Aan/uit",
  "admin.googleLogin.saveError": "De Google-logininstelling kon niet opgeslagen worden.",
  "admin.microsoftLogin.sectionTitle": "Microsoft-login",
  "admin.microsoftLogin.sectionDescription": "Bepaal of bezoekers nog mogen inloggen of een account aanmaken via Microsoft. De knop op de loginpagina volgt deze instelling meteen.",
  "admin.microsoftLogin.enabled": "Microsoft-login actief",
  "admin.microsoftLogin.disabled": "Microsoft-login uitgeschakeld",
  "admin.microsoftLogin.toggleLabel": "Aan/uit",
  "admin.microsoftLogin.saveError": "De Microsoft-logininstelling kon niet opgeslagen worden.",
  "admin.userCount": "{count} gebruikers",
  "admin.col.provider": "Provider",
  "admin.col.effectiveDisplayName": "Naam",
  "admin.col.email": "E-mail",
  "admin.col.id": "Id",
  "admin.col.externalId": "ExternalId",
  "admin.col.createdAt": "Aangemaakt",
  "admin.col.lastLoggedIn": "Laatst ingelogd",
  "admin.col.blocked": "Status",
  "admin.col.onboarding": "Onboarding",
  "admin.col.business": "Zakelijk",
  "admin.col.role": "Rol",
  "admin.active": "Actief",
  "admin.blocked": "Geblokkeerd",
  "admin.completed": "Voltooid",
  "admin.notCompleted": "Niet voltooid",
  "admin.yes": "Ja",
  "admin.no": "Nee",
  "admin.role.admin": "Admin",
  "admin.role.landlord": "Verhuurder",
  "admin.viewDetails": "Details bekijken",
  "admin.filter.email": "E-mail",
  "admin.filter.name": "Naam",
  "admin.filter.namePlaceholder": "Zoek op naam",
  "admin.filter.emailPlaceholder": "Zoek op e-mail",
  "admin.filter.id": "Id",
  "admin.filter.idPlaceholder": "Zoek op id of externalId",
  "admin.filter.business": "Zakelijk",
  "admin.filter.onboarding": "Onboarding",
  "admin.filter.all": "Alles",
  "admin.filter.apply": "Filter toepassen",
  "admin.filter.reset": "Reset",
  "admin.noResults": "Geen gebruikers gevonden.",
  "admin.billingDocuments.count": "{count} documenten",
  "admin.billingDocuments.col.number": "Nummer",
  "admin.billingDocuments.col.firstName": "Voornaam",
  "admin.billingDocuments.col.lastName": "Naam",
  "admin.billingDocuments.col.amount": "Bedrag",
  "admin.billingDocuments.col.date": "Datum",
  "admin.invoices.loadError": "Fout bij het laden van facturen.",
  "admin.invoices.title": "Platformfacturen",
  "admin.invoices.subtitle": "Overzicht van alle facturen binnen het platform, met download per rij.",
  "admin.invoices.empty": "Geen facturen gevonden.",
  "admin.creditNotes.loadError": "Fout bij het laden van creditnota's.",
  "admin.creditNotes.title": "Platformcreditnota's",
  "admin.creditNotes.subtitle": "Overzicht van alle creditnota's binnen het platform, met download per rij.",
  "admin.creditNotes.empty": "Geen creditnota's gevonden.",
  "admin.revenue.loadError": "Fout bij het laden van het omzetoverzicht.",
  "admin.revenue.title": "Gerealiseerde omzet per kalenderjaar",
  "admin.revenue.subtitle": "Netto overzicht van betaalde facturen en creditnota's vanaf kalenderjaar 2026.",
  "admin.revenue.empty": "Geen omzetgegevens gevonden.",
  "admin.revenue.totalLabel": "Totaal sinds 2026",
  "admin.revenue.yearsTrackedLabel": "Kalenderjaren in overzicht",
  "admin.revenue.col.year": "Jaar",
  "admin.revenue.col.amount": "Omzet",
  "admin.revenue.col.invoices": "Facturen",
  "admin.revenue.col.creditNotes": "Creditnota's",
  "admin.errors.loadError": "Fout bij het laden van application errors.",
  "admin.errors.count": "{count} errors",
  "admin.errors.noResults": "Geen application errors gevonden.",
  "admin.errors.viewDetails": "Errordetails bekijken",
  "admin.errors.delete": "Error verwijderen",
  "admin.errors.confirmDelete": "Weet je zeker dat je deze application error wilt verwijderen?",
  "admin.errors.deleteSuccess": "Application error verwijderd.",
  "admin.errors.deleteError": "Application error kon niet verwijderd worden.",
  "admin.errors.filter.functionName": "Function",
  "admin.errors.filter.functionNamePlaceholder": "Zoek op functionnaam",
  "admin.errors.filter.path": "Pad",
  "admin.errors.filter.pathPlaceholder": "Zoek op endpointpad",
  "admin.errors.filter.method": "Methode",
  "admin.errors.filter.userId": "Gebruikers-ID",
  "admin.errors.filter.userIdPlaceholder": "Zoek op gebruikers-id",
  "admin.errors.filter.search": "Vrij zoeken",
  "admin.errors.filter.searchPlaceholder": "Zoek in message, stack trace, metadata...",
  "admin.errors.filter.statusCode": "Statuscode",
  "admin.errors.filter.occurredFrom": "Vanaf datum",
  "admin.errors.filter.occurredTo": "Tot datum",
  "admin.errors.col.occurredAt": "Tijdstip",
  "admin.errors.col.statusCode": "Status",
  "admin.errors.col.method": "Methode",
  "admin.errors.col.path": "Pad",
  "admin.errors.col.functionName": "Function",
  "admin.errors.col.exceptionType": "Exceptiontype",
  "admin.errors.col.message": "Bericht",
  "admin.errors.col.userId": "Gebruikers-ID",
  "admin.errors.col.invocationId": "Invocation ID",
  "admin.errors.col.stackTrace": "Stack trace",
  "admin.errors.col.metadata": "Metadata",
  "admin.pagination.summary": "{start}-{end} van {total}",
  "admin.pagination.page": "Pagina {page} van {totalPages}",
  "admin.pagination.previous": "Vorige",
  "admin.pagination.next": "Volgende",
  "admin.pagination.noResults": "0 resultaten",
  "admin.subscription.currentSummary": "Huidige abonnementsgegevens",
  "admin.subscription.currentPlan": "Plan",
  "admin.subscription.provider": "Betaalbron",
  "admin.subscription.customerId": "Provider customer ID",
  "admin.subscription.status": "Status",
  "admin.subscription.startsAt": "Start",
  "admin.subscription.endsAt": "Einde",
  "admin.subscription.none": "Geen",
  "admin.subscription.formTitle": "Abonnement manueel aanpassen",
  "admin.subscription.formDescription": "Stel voor dit account een abonnementsperiode in zonder betaling. Accounts met een provider-abonnement moeten eerst gestopt of afgelopen zijn.",
  "admin.subscription.plan": "Abonnement",
  "admin.subscription.interval": "Interval",
  "admin.subscription.interval.monthly": "Maandelijks",
  "admin.subscription.interval.yearly": "Jaarlijks",
  "admin.subscription.startDate": "Startdatum",
  "admin.subscription.endDate": "Einddatum",
  "admin.subscription.noPlans": "Er zijn momenteel geen abonnementen beschikbaar om te kiezen.",
  "admin.subscription.loadPlansError": "De abonnementsopties konden niet geladen worden.",
  "admin.subscription.saveError": "De abonnementswijziging kon niet opgeslagen worden.",
  "admin.subscription.periodError": "De einddatum moet na de startdatum liggen.",
  "admin.subscription.required": "Vul alle abonnementsvelden in.",
  "admin.subscription.protectedTitle": "Abonnement van admin-account is beschermd",
  "admin.subscription.protectedBody": "Gebruikers met de rol Admin kunnen niet manueel een abonnement toegewezen krijgen via het admin-scherm.",
  "admin.subscription.status.active": "Actief",
  "admin.subscription.status.pastDue": "Achterstallig",
  "admin.subscription.status.canceled": "Geannuleerd",
  "admin.subscription.status.trialing": "Proefperiode",
  "admin.subscription.startAccess": "Nieuwe betaalde starts",
  "admin.subscription.startAllowed": "Toegelaten",
  "admin.subscription.startBlocked": "Geblokkeerd",
  "admin.userDelete.sectionTitle": "Gebruiker definitief verwijderen",
  "admin.userDelete.sectionDescription": "Verwijder deze gebruiker alleen wanneer het volledige account en alle gekoppelde gegevens permanent weg mogen.",
  "admin.userDelete.openButton": "Gebruiker verwijderen",
  "admin.userDelete.dialogTitle": "Gebruiker definitief verwijderen",
  "admin.userDelete.warningTitle": "Let op: deze actie kan niet ongedaan gemaakt worden.",
  "admin.userDelete.warningIntro": "Je staat op het punt om het account van {email} permanent te verwijderen.",
  "admin.userDelete.consequenceData": "Alle gegevens van deze gebruiker worden verwijderd uit het admin-gedeelte en uit alle gekoppelde tabellen.",
  "admin.userDelete.consequenceFiles": "Alle gekoppelde bestanden zoals foto's, documenten en factuurbestanden worden mee verwijderd.",
  "admin.userDelete.consequenceBilling": "Actieve provider-beheerde abonnementen worden eerst stopgezet zodat er geen verdere aanrekeningen meer gebeuren.",
  "admin.userDelete.consequenceIrreversible": "Na bevestiging kan deze gebruiker niet meer hersteld worden.",
  "admin.userDelete.confirmLabel": "Definitief verwijderen",
  "admin.userDelete.deleteError": "De gebruiker kon niet verwijderd worden.",
  "admin.userBlock.sectionTitle": "Toegang blokkeren",
  "admin.userBlock.sectionDescription": "Blokkeer dit account om toekomstige aanmeldingen en API-toegang meteen te stoppen.",
  "admin.userBlock.blockButton": "Gebruiker blokkeren",
  "admin.userBlock.unblockButton": "Gebruiker deblokkeren",
  "admin.userBlock.dialogTitleBlock": "Gebruiker blokkeren",
  "admin.userBlock.dialogTitleUnblock": "Gebruiker deblokkeren",
  "admin.userBlock.warningTitleBlock": "Deze gebruiker verliest direct toegang.",
  "admin.userBlock.warningTitleUnblock": "Deze gebruiker krijgt opnieuw toegang.",
  "admin.userBlock.warningIntroBlock": "Na bevestiging ziet de gebruiker bij het aanmelden dat het account geblokkeerd is en contact met de helpdesk nodig is.",
  "admin.userBlock.warningIntroUnblock": "Na bevestiging kan de gebruiker opnieuw aanmelden met het bestaande account.",
  "admin.userBlock.confirmBlock": "Blokkeren",
  "admin.userBlock.confirmUnblock": "Deblokkeren",
  "admin.userBlock.saveError": "De blokkering kon niet opgeslagen worden.",
  "admin.bulkSubscription.cancelSelected": "Selectie stopzetten",
  "admin.bulkSubscription.cancelAllPaid": "Alle betalende abonnementen stopzetten",
  "admin.bulkSubscription.dialogTitleSelected": "Geselecteerde abonnementen stopzetten",
  "admin.bulkSubscription.dialogSubtitleSelected": "{count} gebruiker(s) worden meteen stopgezet, pro-rata terugbetaald en geblokkeerd voor nieuwe betaalde abonnementen.",
  "admin.bulkSubscription.dialogTitleAllPaid": "Alle betalende abonnementen stopzetten",
  "admin.bulkSubscription.dialogSubtitleAllPaid": "Deze actie geldt voor alle gebruikers met een betalend abonnement op het hele Rentomax-platform.",
  "admin.bulkSubscription.warningTitle": "Deze actie stopt abonnementen onmiddellijk.",
  "admin.bulkSubscription.warningBodySelected": "Na bevestiging worden toekomstige verlengingen meteen gestopt, de resterende betaalde periode pro-rata terugbetaald en kunnen deze accounts geen nieuw betalend abonnement meer starten.",
  "admin.bulkSubscription.warningBodyAllPaid": "Na bevestiging worden toekomstige verlengingen platformbreed meteen gestopt, de resterende betaalde periode pro-rata terugbetaald en kunnen deze accounts geen nieuw betalend abonnement meer starten.",
  "admin.bulkSubscription.confirmSelected": "Selectie stopzetten",
  "admin.bulkSubscription.confirmAllPaid": "Alles stopzetten",
  "admin.bulkSubscription.confirmationLabel": "Typ rentomax om te bevestigen",
  "admin.bulkSubscription.confirmationPlaceholder": "rentomax",
  "admin.bulkSubscription.confirmationHelp": "De bevestigknop wordt pas actief wanneer je exact rentomax invult.",
  "admin.bulkSubscription.confirmationMismatch": "Typ exact rentomax om deze actie te bevestigen.",
  "admin.bulkSubscription.saveError": "De bulkstopzetting kon niet uitgevoerd worden.",
  "admin.protectedAccount.title": "Beschermd admin-account",
  "admin.protectedAccount.body": "Gebruikers met de rol Admin kunnen niet manueel een abonnement toegewezen krijgen, geblokkeerd of verwijderd worden.",
  "contractTimeline.title": "Contracten tijdslijn",
  "contractTimeline.subtitle": "Visueel overzicht van alle huurcontracten per pand",
  "contractTimeline.today": "Vandaag",
  "contractTimeline.openEnded": "geen einddatum",
  "contractTimeline.vacant": "Leeg",
  "contractTimeline.noProperties": "Je hebt nog geen panden toegevoegd.",
  "contractTimeline.addProperty": "Pand toevoegen",
  "contractTimeline.loadError": "Fout bij het laden van de tijdslijn",
  "contractTimeline.legend.active": "Actief",
  "contractTimeline.legend.endingSoon": "Eindigt binnen 3 maanden",
  "contractTimeline.legend.ended": "Beeindigd",
  "contractTimeline.legend.inactive": "Inactief",
  "contractTimeline.legend.vacant": "Leeg / geen contract",
  "notifications.triggerAriaLabel": "Notificaties openen",
  "notifications.title": "Notificaties",
  "notifications.unreadCount": "{count} ongelezen",
  "notifications.markAllRead": "Markeer alles als gelezen",
  "notifications.deleteAllAriaLabel": "Verwijder alle notificaties",
  "notifications.deleteSingleAriaLabel": "Verwijder notificatie",
  "notifications.confirmDeleteSingle": "Wil je deze notificatie verwijderen?",
  "notifications.confirmDeleteAll": "Wil je alle notificaties verwijderen?",
  "notifications.hiddenUnreadCount": "Nog {count} oudere ongelezen notificaties",
  "notifications.showAllUnread": "Toon alle ongelezen",
  "notifications.showFewerUnread": "Toon minder",
  "notifications.readSection": "Recent gelezen",
  "notifications.empty": "Nog geen notificaties.",
  "notifications.loadError": "Notificaties konden niet geladen worden.",
  "notifications.generic.title": "Nieuwe update",
  "notifications.generic.message": "Open de notificatie om de details te bekijken.",
  "notifications.tenantApplicationAssigned.title": "Nieuwe kandidaatstelling",
  "notifications.tenantApplicationAssigned.message": "{propertyAddress} werd als kandidaatstelling aan je huurderportaal toegevoegd.",
  "notifications.tenantAgreementAssigned.title": "Nieuwe huurovereenkomst",
  "notifications.tenantAgreementAssigned.message": "{propertyAddress} werd toegevoegd aan je huurderportaal.",
  "notifications.tenantAgreementUpdated.title": "Huurovereenkomst gewijzigd",
  "notifications.tenantAgreementUpdated.message": "Er zijn nieuwe details voor {propertyAddress}. Open de huurovereenkomst om alles te bekijken.",
  "notifications.tenantAgreementEndingSoon.title": "Huurovereenkomst loopt af",
  "notifications.tenantAgreementEndingSoon.message": "Je huurovereenkomst voor {propertyAddress} loopt af op {endDate}.",
  "notifications.reminderOverdue.title": "Reminder vervallen",
  "notifications.reminderOverdue.message": "{title} is vervallen op {dueDate}.",
  "notifications.surveyResponse.title": "Survey ingevuld",
  "notifications.surveyResponse.message": "{tenantName} heeft de tevredenheidspeiling voor {year} ingevuld.",
  "notifications.damageReportCreated.title": "Nieuwe schademelding",
  "notifications.damageReportCreated.message": "{tenantName} meldde een probleem voor {propertyAddress}.",
  "survey.sectionTitle": "Tevredenheidspeiling",
  "survey.sendButton": "Stuur peiling",
  "survey.resendButton": "Stuur opnieuw",
  "survey.sending": "Versturen...",
  "survey.sendSuccess": "Peiling verstuurd",
  "survey.sendError": "Versturen mislukt",
  "survey.alreadySentThisYear": "Al verstuurd dit jaar",
  "survey.onlyLatestAgreementYear": "Alleen in het laatste actieve huurjaar",
  "survey.noEmail": "Huurder heeft geen e-mailadres",
  "survey.noEmailHint": "Het is niet mogelijk om een peiling te sturen als er geen e-mailadres van de huurder beschikbaar is.",
  "survey.rating": "Score",
  "survey.comment": "Opmerking",
  "survey.answered": "Beantwoord",
  "survey.pending": "Wacht op antwoord",
  "survey.year": "Jaar",
  "survey.noResults": "Nog geen peilingen verstuurd",
  "survey.stars": "sterren",
  "common.rentAmount": "Huurprijs",
  "common.rentAmountPerMonth": "Huurprijs (EUR/maand)",
  "common.rentAmountPlaceholder": "bv. 850.00",
  "tenant.form.lastName": "Achternaam",
  "tenant.form.addTitle": "Nieuwe huurder",
  "tenant.form.editTitle": "Huurder bewerken",
  "tenant.form.currentlyRunning": "heden",
  "agreement.editTitle": "Huurovereenkomst bewerken",
  "agreement.updateError": "De huurovereenkomst kon niet bijgewerkt worden.",
  "agreement.rentChange.title": "Huurprijs wijzigen",
  "agreement.rentChange.error": "De huurprijswijziging kon niet opgeslagen worden.",
  "agreement.rentChange.currentEndDate": "Einddatum huidige overeenkomst",
  "agreement.rentChange.newStartDate": "Startdatum nieuwe overeenkomst",
  "property.addressPlaceholder": "Straat 1, 1000 Stad",
  "property.form.structureType": "Structuur",
  "property.form.name": "Naam",
  "property.form.namePlaceholder": "Bijvoorbeeld Residentie Parkzicht",
  "property.form.unitLabel": "Unitlabel",
  "property.form.unitLabelPlaceholder": "Bijvoorbeeld 1A",
  "property.form.units": "Units",
  "property.form.unitsPlaceholder": "1A\n1B\n2A",
  "property.form.unitsHint": "Voeg een unitlabel per regel toe. Elke unit krijgt een eigen dossier.",
  "property.structure.standalone": "Los pand",
  "property.structure.building": "Gebouw met units",
  "property.structure.unit": "Unit",
  "property.descriptionPlaceholder": "Optionele beschrijving...",
  "property.notifications.sectionTitle": "Notificatievoorkeuren per pand",
  "property.notifications.sectionDescription": "Stel per type in of je een reminder wilt ontvangen en hoelang op voorhand.",
  "property.notifications.leadTimeLabel": "Voorlooptijd voor {label}",
  "property.notifications.unit.days": "dagen",
  "property.notifications.unit.months": "maanden",
  "property.notifications.contractEnd.label": "Contracteinde",
  "property.notifications.contractEnd.hint": "Waarschuw voor het einde van een lopend huurcontract.",
  "property.notifications.epcExpiry.label": "EPC-verval",
  "property.notifications.epcExpiry.hint": "Waarschuw voordat het gekoppelde EPC-document vervalt.",
  "property.notifications.insuranceExpiry.label": "Verzekering",
  "property.notifications.insuranceExpiry.hint": "Waarschuw voordat een verzekeringsdocument vervalt.",
  "property.form.addTitle": "Nieuw pand",
  "property.form.editTitle": "Pand bewerken",
  "property.form.linkTenantTitle": "Bestaande huurder koppelen",
  "property.form.noAvailableTenants": "Geen beschikbare huurders om te koppelen.",
  "property.form.linkTenantButton": "Koppelen",
  "property.form.documentTypeLabel": "Documenttype",
  "property.form.addTenantError": "De huurder kon niet toegevoegd worden.",
  "property.form.linkTenantError": "De huurder kon niet gekoppeld worden.",
  "property.form.reminderError": "De reminder kon niet opgeslagen worden.",
  "waitinglist.form.addTitle": "Nieuwe kandidaat",
  "waitinglist.form.editTitle": "Kandidaat bewerken",
  "waitinglist.form.personLabel": "Persoon",
  "waitinglist.form.personModeNewTitle": "Nieuwe persoon",
  "waitinglist.form.personModeNewDescription": "Voeg een kandidaat toe met nieuwe contactgegevens.",
  "waitinglist.form.personModeExistingTitle": "Gekende persoon",
  "waitinglist.form.personModeExistingDescription": "Kies iemand die al eerder in Rentomax is opgeslagen.",
  "waitinglist.form.selectPerson": "Selecteer persoon",
  "waitinglist.form.selectPlaceholder": "-- Selecteer --",
  "waitinglist.form.loadingKnownPersons": "Gekende personen laden...",
  "waitinglist.form.noKnownPersons": "Geen gekende personen",
  "waitinglist.form.rentomaxLookupHint": "Voeg een e-mailadres toe om te controleren of deze kandidaat al een Rentomax-account heeft.",
  "waitinglist.form.rentomaxLookupLoading": "Rentomax-account controleren...",
  "waitinglist.form.rentomaxLookupError": "Het Rentomax-account kon niet gecontroleerd worden. Je kan wel verder zonder koppeling.",
  "waitinglist.form.rentomaxKnownAccount": "Deze kandidaat heeft al een Rentomax-account via {provider}.",
  "waitinglist.form.rentomaxNoAccount": "Deze kandidaat heeft nog geen Rentomax-account. Je kan een gratis uitnodiging sturen, en aanmelden kan via e-mail, Google of Microsoft.",
  "waitinglist.form.rentomaxActionLabel": "Rentomax-koppeling",
  "waitinglist.form.rentomaxAction.noneTitle": "Geen koppeling leggen",
  "waitinglist.form.rentomaxAction.noneDescriptionKnown": "Bewaar deze kandidaat enkel informatief voor de verhuurder. De kandidaat ziet niets in het huurder-portaal.",
  "waitinglist.form.rentomaxAction.noneDescriptionUnknown": "Bewaar deze kandidaat enkel informatief voor de verhuurder, zonder Rentomax-uitnodiging.",
  "waitinglist.form.rentomaxAction.linkTitle": "Bestaand Rentomax-account koppelen",
  "waitinglist.form.rentomaxAction.linkDescription": "Toon de kandidaatstelling meteen in het huurder-portaal en stuur een Rentomax-notificatie.",
  "waitinglist.form.rentomaxAction.inviteTitle": "Gratis Rentomax-account uitnodigen",
  "waitinglist.form.rentomaxAction.inviteDescription": "Verstuur een gratis uitnodiging. Accountaanmaak verloopt via e-mail, Google of Microsoft.",
  "waitinglist.form.interestDateLabel": "Datum van interesse",
  "waitinglist.form.notesPlaceholder": "Bijzonderheden, opmerkingen...",
  "waitinglist.form.convertTitle": "Omzetten naar {status}",
  "waitinglist.form.convertDescription": "De kandidaat wordt omgezet naar een actieve huurder. Stel hieronder de huurvoorwaarden in. Na omzetting kan de kandidaatkaart niet meer bewerkt worden.",
  "waitinglist.form.convertSubmit": "Omzetten naar {status}",
  "waitinglist.inviteButton": "Uitnodigen",
  "waitinglist.inviteResendButton": "Opnieuw uitnodigen",
  "waitinglist.inviteSentLabel": "Uitnodiging verzonden",
  "waitinglist.inviteDialogTitle": "Nodig kandidaat-huurder uit",
  "waitinglist.inviteDialogFreeNote": "In de e-mail maken we duidelijk dat een huurder-account op Rentomax gratis is en gratis blijft.",
  "waitinglist.inviteDialogMessageLabel": "Persoonlijk bericht voor in de e-mail",
  "waitinglist.inviteDialogMessagePlaceholder": "Voeg optioneel een korte persoonlijke boodschap toe.",
  "waitinglist.inviteSend": "Uitnodiging versturen",
  "waitinglist.inviteSending": "Uitnodiging wordt verstuurd...",
  "waitinglist.inviteSuccess": "De uitnodiging werd verstuurd. Rechtstreekse link:",
  "waitinglist.inviteError": "De uitnodiging kon niet verstuurd worden.",
  "waitinglist.portalStatus.has-account-unlinked.label": "Rentomax gekend, niet gekoppeld",
  "waitinglist.portalStatus.has-account-unlinked.tooltip": "Kandidaat heeft al een Rentomax-account, maar is nog niet gekoppeld aan deze kandidaatstelling.",
  "waitinglist.portalStatus.no-account-unlinked.label": "Geen Rentomax, geen koppeling",
  "waitinglist.portalStatus.no-account-unlinked.tooltip": "Kandidaat heeft nog geen Rentomax-account en er is nog geen koppeling of uitnodiging voorzien.",
  "waitinglist.portalStatus.has-account-linked.label": "Rentomax gekoppeld",
  "waitinglist.portalStatus.has-account-linked.tooltip": "Kandidaat heeft een Rentomax-account en is gekoppeld aan deze kandidaatstelling.",
  "waitinglist.portalStatus.no-account-invite-sent.label": "Uitnodiging verstuurd",
  "waitinglist.portalStatus.no-account-invite-sent.tooltip": "Kandidaat heeft nog geen Rentomax-account. Er werd al een gratis uitnodiging verstuurd om zich via e-mail, Google of Microsoft aan te melden.",
  "waitinglist.form.saveError": "De kandidaat kon niet opgeslagen worden.",
  "waitinglist.form.convertError": "De kandidaat kon niet omgezet worden.",
  "waitinglist.deleteError": "De kandidaat kon niet verwijderd worden.",
  "timeline.confirmDelete": "Weet je zeker dat je dit event wilt verwijderen?",
  "onboarding.step.profile": "Profiel",
  "onboarding.step.property": "Pand",
  "onboarding.step.tenant": "Huurder",
  "onboarding.step.document": "Document",
  "onboarding.step.reminder": "Reminder",
  "onboarding.sidebarTitle": "Snel aan de slag",
  "onboarding.sidebarSubtitle": "Volg deze {count} stappen om alles in te stellen. In je profiel kies je tussen een particulier of zakelijk account en vul je je adresgegevens in.",
  "onboarding.progressLabel": "{completed} van {total} voltooid",
  "onboarding.stepBadge": "Stap {current} van {total}",
  "onboarding.skipStep": "Stap overslaan",
  "onboarding.profile.title": "Vul je verhuurdersprofiel aan",
  "onboarding.profile.description": "Kies je accounttype en vul je adresgegevens in. Voor een zakelijk account zijn een bedrijfsnaam en btw-nummer verplicht en kun je optioneel een facturatie-adres bewaren.",
  "onboarding.profile.billingHelp": "Optioneel. Laat leeg als dit hetzelfde is als je gewone adres.",
  "onboarding.profile.next": "Volgende: Pand toevoegen",
  "onboarding.property.title": "Voeg je eerste pand toe",
  "onboarding.property.description": "Vul het adres in van het pand dat je beheert. Je kunt later altijd meer panden toevoegen.",
  "onboarding.property.typeLabel": "Type pand",
  "onboarding.property.next": "Volgende: Huurder toevoegen",
  "onboarding.tenant.title": "Koppel een huurder",
  "onboarding.tenant.description": "Voeg de eerste huurder toe voor {property}.",
  "onboarding.tenant.descriptionNoProperty": "Voeg de eerste huurder toe voor je pand.",
  "onboarding.tenant.firstNamePlaceholder": "Jan",
  "onboarding.tenant.lastNamePlaceholder": "Janssen",
  "onboarding.tenant.next": "Volgende: Document toevoegen",
  "onboarding.document.title": "Upload een eerste document",
  "onboarding.document.description": "Voeg een document toe zoals een EPC-attest, huurcontract of verzekeringspolis. Je kunt deze stap ook overslaan.",
  "onboarding.document.typeLabel": "Documenttype",
  "onboarding.document.uploadedNotice": "Geüpload",
  "onboarding.document.uploadedHint": "Selecteer een nieuw bestand hieronder om dit te vervangen.",
  "onboarding.document.optionalReplace": "(optioneel - vervangt huidig document)",
  "onboarding.document.fileDropIcon": "Bestand",
  "onboarding.document.fileDropText": "Sleep een bestand hierheen of klik om te bladeren",
  "onboarding.document.fileDropHint": "PDF, JPG, PNG - max. 20 MB",
  "onboarding.document.next": "Volgende: Reminder instellen",
  "onboarding.csvImportFileRequired": "Kies eerst het ingevulde CSV-bestand.",
  "onboarding.csvImportSuccess": "{propertyCount} panden en {tenantCount} huurders geïmporteerd.",
  "onboarding.csvImportRowError": "Rij {rowNumber}: {message}",
  "onboarding.csvImportInvalidData": "Ongeldige gegevens.",
  "onboarding.csvImportError": "De import is mislukt. Probeer opnieuw met het templatebestand.",
  "onboarding.error.companyNameRequired": "Vul een bedrijfsnaam in.",
  "onboarding.error.profileRequired": "Vul straat, huisnummer, postcode, stad en land in.",
  "onboarding.error.countryNotAllowed": "Dit land is niet toegestaan op Rentomax.",
  "onboarding.error.propertyAddressRequired": "Vul een adres in voor het pand.",
  "onboarding.error.tenantRequired": "Vul de verplichte huurdersgegevens in of sla deze stap over.",
  "onboarding.error.documentFileRequired": "Kies een bestand om te uploaden, of sla deze stap over.",
  "onboarding.error.reminderRequired": "Vul een omschrijving en datum in of sla deze stap over.",
  "onboarding.error.vatNumberRequired": "Vul een btw-nummer in.",
  "onboarding.error.complete": "Onboarding kon niet worden afgerond.",
  "survey.public.loading": "Laden...",
  "survey.public.notFoundTitle": "Peiling niet gevonden",
  "survey.public.notFoundBody": "Deze link is ongeldig of verlopen.",
  "survey.public.errorTitle": "Er is iets misgegaan",
  "survey.public.errorBody": "Probeer de pagina opnieuw te laden.",
  "survey.public.answeredTitle": "U heeft al geantwoord",
  "survey.public.answeredBody": "Uw antwoord voor {year} werd al geregistreerd. Bedankt!",
  "survey.public.submittedTitle": "Bedankt voor uw feedback!",
  "survey.public.submittedBody": "Uw antwoord werd doorgestuurd naar {landlordName}.",
  "survey.public.formTitle": "Hoe tevreden bent u met uw huurwoning en de dienstverlening?",
  "survey.public.starLabel": "{count} ster",
  "survey.public.commentPlaceholder": "Optionele opmerking...",
  "survey.public.submit": "Verstuur mijn antwoord",
  "survey.public.submitting": "Versturen...",
  "survey.public.ratingError": "Gelieve een score te kiezen (1–5 sterren).",
  "common.daysShort": "{count}d",
  "common.daysAgo": "{count} dagen geleden",
  "common.daysRemaining": "{count} dagen resterend",
  "common.processing": "Bezig...",
  "document.type.epc": "EPC",
  "onboarding.reminder.title": "Stel een eerste reminder in",
  "onboarding.reminder.description": "Reminders helpen je om deadlines en taken overzichtelijk op te volgen. Maak er alvast eentje aan.",
  "onboarding.reminder.suggestionsLabel": "Snelle suggesties:",
  "onboarding.reminder.suggestion.epcLabel": "EPC hernieuwen",
  "onboarding.reminder.suggestion.epcTitle": "EPC-attest hernieuwen",
  "onboarding.reminder.suggestion.electricalLabel": "Elektrische keuring",
  "onboarding.reminder.suggestion.electricalTitle": "Elektrische keuring",
  "onboarding.reminder.suggestion.insuranceLabel": "Brandverzekering",
  "onboarding.reminder.suggestion.insuranceTitle": "Brandverzekering verlengen",
  "onboarding.reminder.suggestion.indexationLabel": "Huurindexatie",
  "onboarding.reminder.suggestion.indexationTitle": "Huurindexatie opvolgen",
  "onboarding.reminder.titlePlaceholder": "Bijv. EPC-attest hernieuwen",
  "onboarding.reminder.checkoutDescription": "Na deze stap sturen we je door naar Mollie om je abonnement te starten.",
  "onboarding.reminder.dashboardDescription": "Na deze stap ronden we je onboarding af en ga je meteen naar je dashboard met je proefversie.",
  "onboarding.reminder.skipCheckout": "Stap overslaan - naar Mollie",
  "onboarding.reminder.finishCheckout": "Afronden - naar Mollie",
  "onboarding.reminder.finishDashboard": "Afronden - naar dashboard",
  "onboarding.reminder.finish": "Klaar - naar dashboard",
  "agreement.rentChange.currentAgreementStep": "Huidige<br>overeenkomst",
  "agreement.rentChange.newAgreementStep": "Nieuwe<br>overeenkomst",
  "agreement.rentChange.confirmStep": "Bevestiging",
  "agreement.rentChange.closeCurrentHelp": "Sluit de huidige overeenkomst af door een einddatum in te vullen.",
  "agreement.rentChange.setupNewHelp": "Stel de nieuwe overeenkomst in die start na de afsluiting.",
  "agreement.rentChange.reviewHelp": "Controleer de wijzigingen en bevestig.",
  "agreement.rentChange.newRentAmount": "Nieuwe huurprijs (EUR/maand)",
  "property.documents.empty": "Geen documenten voor dit pand.",
  "property.reminders.empty": "Geen reminders voor dit pand.",
  "property.tenants.addButton": "Nieuwe huurder",
  "property.tenants.linkExistingButton": "Bestaande koppelen",
  "property.tenants.empty": "Geen huurders gekoppeld aan dit pand.",
  "tenant.documents.empty": "Geen documenten voor deze huurder.",
  "tenant.timeline.allAgreements": "Alle huurovereenkomsten",
  "tenantWelcome.sectionTitle": "Welkomstpagina",
  "tenantWelcome.manageButton": "Welkomstpagina",
  "tenantWelcome.status.notConfigured": "Niet ingesteld",
  "tenantWelcome.status.inactive": "Inactief",
  "tenantWelcome.status.active": "Actief",
  "tenantWelcome.status.ended": "Geblokkeerd voor vorige huurder",
  "tenantWelcome.publicLink": "Persoonlijke link",
  "tenantWelcome.linkUnavailable": "Sla de welkomstpagina eerst op om een persoonlijke link te genereren.",
  "tenantWelcome.help": "Bundel vaste praktische info voor deze huurder op een persoonlijke pagina zonder account. De link toont altijd de laatste versie.",
  "tenantWelcome.pageTitle": "Titel",
  "tenantWelcome.pageTitlePlaceholder": "Welkom in je woning",
  "tenantWelcome.introduction": "Intro",
  "tenantWelcome.introductionPlaceholder": "Korte welkomstekst of praktische eerste uitleg...",
  "tenantWelcome.houseRules": "Huisregels",
  "tenantWelcome.houseRulesPlaceholder": "Bijvoorbeeld: stilte na 22u, gemeenschappelijke delen netjes houden...",
  "tenantWelcome.wifiName": "Wifi-netwerk",
  "tenantWelcome.wifiNamePlaceholder": "Naam van het wifi-netwerk",
  "tenantWelcome.wifiPassword": "Wifi-wachtwoord",
  "tenantWelcome.wifiPasswordPlaceholder": "Wifi-wachtwoord",
  "tenantWelcome.trashCollectionInfo": "Vuilnisophaling",
  "tenantWelcome.trashCollectionPlaceholder": "Welke dag, welk afval en waar het buiten moet staan...",
  "tenantWelcome.parkingInfo": "Parkeerinfo",
  "tenantWelcome.parkingPlaceholder": "Waar mag de huurder parkeren? Is er een badge of code?",
  "tenantWelcome.additionalInfo": "Extra info",
  "tenantWelcome.additionalInfoPlaceholder": "Alles wat nog nuttig is: kelder, meterstanden, fietsenstalling...",
  "tenantWelcome.contactsTitle": "Noodcontacten",
  "tenantWelcome.addContact": "Contact toevoegen",
  "tenantWelcome.contactLabelPlaceholder": "Bijvoorbeeld loodgieter",
  "tenantWelcome.contactNamePlaceholder": "Naam",
  "tenantWelcome.contactPhonePlaceholder": "Telefoonnummer",
  "tenantWelcome.saveDraft": "Opslaan",
  "tenantWelcome.activateButton": "Activeren",
  "tenantWelcome.inactiveWarning": "Deze welkomstpagina is momenteel niet actief.",
  "tenantWelcome.deactivateButton": "Deactiveren",
  "tenantWelcome.copyLink": "Link kopieren",
  "tenantWelcome.copySuccess": "Link gekopieerd.",
  "tenantWelcome.copyError": "Link kopieren mislukt.",
  "tenantWelcome.qrTitle": "QR-code voor huurder",
  "tenantWelcome.qrHelp": "Deze QR-code opent rechtstreeks de publieke welkomstpagina met het publieke schadeformulier voor deze huurder.",
  "tenantWelcome.qrAlt": "QR-code naar publieke welkomstpagina",
  "tenantWelcome.qrError": "De QR-code kon niet gegenereerd worden.",
  "tenantWelcome.printQr": "QR-code afdrukken",
  "tenantWelcome.printQrError": "Het afdrukvenster kon niet geopend worden.",
  "tenantWelcome.printTitle": "QR-code voor huurder",
  "tenantWelcome.qrPrintEyebrow": "Scan om schade te melden",
  "tenantWelcome.qrPrintBody": "Scan deze code om de publieke welkomstpagina en het schadeformulier van deze woning te openen.",
  "tenantWelcome.openPublicPage": "Open publieke pagina",
  "tenantWelcome.endedTenantWarning": "Deze huurder heeft geen actieve huurrelatie meer. De publieke pagina blijft geblokkeerd tot je opnieuw een actieve huurperiode hebt.",
  "tenantWelcome.updatedAt": "Laatste update",
  "tenantWelcome.public.loading": "Laden...",
  "tenantWelcome.public.notFoundTitle": "Welkomstpagina niet gevonden",
  "tenantWelcome.public.notFoundBody": "Deze link is ongeldig of gedeactiveerd.",
  "tenantWelcome.public.errorTitle": "Er is iets misgegaan",
  "tenantWelcome.public.errorBody": "Probeer de pagina opnieuw te laden.",
  "tenantWelcome.public.wifiTitle": "Wifi",
  "tenantWelcome.public.damageReport.title": "Schade melden",
  "tenantWelcome.public.damageReport.helper": "Meld hier snel een schade of probleem voor deze woning. Je verhuurder ontvangt de melding in het dossier.",
  "tenantWelcome.public.damageReport.noLogin": "Zonder login",
  "tenantWelcome.public.damageReport.descriptionLabel": "Wat is er aan de hand?",
  "tenantWelcome.public.damageReport.descriptionPlaceholder": "Beschrijf kort wat er stuk is of waar het probleem zich bevindt.",
  "tenantWelcome.public.damageReport.urgencyLabel": "Urgentie",
  "tenantWelcome.public.damageReport.photosLabel": "Foto's toevoegen",
  "tenantWelcome.public.damageReport.submit": "Schademelding versturen",
  "tenantWelcome.public.damageReport.submitError": "De schademelding kon niet verstuurd worden.",
  "tenantWelcome.public.damageReport.success": "Je melding is verstuurd. De verhuurder kan ze nu opvolgen.",
  "publicProperty.loading": "Laden...",
  "publicProperty.notFoundTitle": "Pandpagina niet gevonden",
  "publicProperty.notFoundBody": "Deze link is ongeldig, gedeactiveerd of vervallen.",
  "publicProperty.errorTitle": "Er is iets misgegaan",
  "publicProperty.errorBody": "Probeer de pagina opnieuw te laden.",
  "publicProperty.hostedBy": "Gedeeld door {name}",
  "publicProperty.noDescription": "De verhuurder heeft nog geen extra beschrijving toegevoegd voor dit pand.",
  "publicProperty.previewType": "Type",
  "publicProperty.previewStatus": "Status",
  "publicProperty.photosCount": "Foto's",
  "publicProperty.galleryTitle": "Fotogalerij",
  "publicProperty.gallerySubtitle": "Een eerste blik op het pand zoals de verhuurder het heeft samengesteld.",
  "publicProperty.galleryEmpty": "Er zijn nog geen foto's beschikbaar voor dit pand.",
  "publicProperty.galleryPhotoAlt": "Pandfoto: {{fileName}}",
  "publicProperty.openPreview": "Open pandfoto {{fileName}}",
  "publicProperty.lightboxTitle": "Pandfoto vergroten",
  "publicProperty.closePreview": "Sluit fotovoorvertoning",
  "publicProperty.previous": "Vorige foto",
  "publicProperty.next": "Volgende foto",
  "publicProperty.position": "Foto {{current}} van {{total}}",
  "publicProperty.applyTitle": "Kandidaat stellen",
  "publicProperty.applySubtitle": "Bevestig via Rentomax dat je je voor dit pand kandidaat wilt stellen.",
  "publicProperty.applySuccess": "Je kandidatuur is geregistreerd. De verhuurder ziet je nu als kandidaat-huurder in Rentomax.",
  "publicProperty.applyLoginRequired": "Meld je aan via e-mail, Google of Microsoft om je kandidaat te stellen.",
  "publicProperty.applyLoginButton": "Aanmelden om te kandideren",
  "publicProperty.applyLandlordModeBlocked": "Met een verhuurder-account kan je je niet kandidaat stellen. Wijzig je accountmodus eerst in Mijn profiel.",
  "publicProperty.applyGoToProfile": "Ga naar Mijn profiel",
  "publicProperty.applyOnboardingRequired": "Vul eerst je huurderprofiel aan met naam en adresgegevens.",
  "publicProperty.applyCompleteProfile": "Profiel vervolledigen",
  "publicProperty.applyConfirmPrompt": "Bevestig dat je je voor dit pand kandidaat wilt stellen.",
  "publicProperty.applyConfirmButton": "Kandidatuur bevestigen",
  "publicProperty.applyBrowserConfirm": "Wil je je voor dit pand kandidaat stellen?",
  "publicProperty.applyError": "Je kandidatuur kon niet worden opgeslagen.",
  "tenantOnboarding.intro": "Vul je naam en adresgegevens aan voordat je je kandidaat stelt.",
  "tenantOnboarding.firstName": "Voornaam",
  "tenantOnboarding.lastName": "Naam",
  "tenantOnboarding.saveAndContinue": "Opslaan en doorgaan",
  "tenantOnboarding.requiredError": "Vul je voornaam, naam en adresgegevens volledig in.",
  "tenantOnboarding.saveError": "Je profiel kon niet worden opgeslagen.",
  "tenantInvite.title": "Maak je gratis huurder-account aan",
  "tenantInvite.subtitle": "Gebruik deze uitnodiging om je dossier in Rentomax te koppelen aan je eigen huurder-account.",
  "tenantInvite.freeNote": "Je huurder-account op Rentomax is volledig gratis en zal ook gratis blijven.",
  "tenantInvite.invitedBySuffix": "heeft je uitgenodigd via Rentomax.",
  "tenantInvite.loginCta": "Verder naar aanmelden via e-mail, Google of Microsoft",
  "tenantInvite.claiming": "We koppelen deze uitnodiging aan je huurder-account...",
  "tenantInvite.success": "Je uitnodiging is gekoppeld.",
  "tenantInvite.successBody": "Je ziet dit dossier nu ook in je huurder-portaal.",
  "tenantInvite.portalCta": "Open mijn huurder-portaal",
  "tenantInvite.profileCta": "Open mijn profiel",
  "tenantInvite.loadError": "Deze uitnodiging is niet beschikbaar.",
  "tenantInvite.claimError": "De uitnodiging kon niet gekoppeld worden.",
  "tenantPortal.title": "Mijn panden",
  "tenantPortal.description": "Bekijk hier voor welke panden je kandidaat bent en welke huurrelaties aan je account gekoppeld zijn.",
  "tenantPortal.candidateTitle": "Kandidaatstellingen",
  "tenantPortal.activeTitle": "Actieve huurovereenkomsten",
  "tenantPortal.futureTitle": "Toekomstige huurovereenkomsten",
  "tenantPortal.pastTitle": "Afgelopen huurovereenkomsten",
  "tenantPortal.eyebrow": "Huurdersportaal",
  "tenantPortal.activeDescription": "Alles wat vandaag effectief aan jouw account gekoppeld is, staat hier samen in een helder overzicht.",
  "tenantPortal.futureDescription": "Hier zie je welke huurrelaties binnenkort starten zodat je vooruit kan plannen.",
  "tenantPortal.candidateDescription": "Volg op voor welke panden je kandidaat bent en bij welke verhuurders je dossier al gekend is.",
  "tenantPortal.pastDescription": "Een rustig archief van eerdere huurrelaties die aan jouw account gekoppeld bleven.",
  "tenantPortal.currentSectionCount": "Items in deze sectie",
  "tenantPortal.navigationLabel": "Navigatie binnen huurdersportaal",
  "tenantPortal.statActive": "Actief nu",
  "tenantPortal.statUpcoming": "Start later",
  "tenantPortal.statApplications": "Kandidaat",
  "tenantPortal.statHistory": "Archief",
  "tenantPortal.propertyStatus": "Pandstatus",
  "tenantPortal.interestDate": "Kandidaat sinds",
  "tenantPortal.startDate": "Startdatum",
  "tenantPortal.endDate": "Einddatum",
  "tenantPortal.rentAmount": "Huurprijs",
  "tenantPortal.viewWelcomePage": "Bekijk welkomstpagina",
  "tenantPortal.notAvailable": "Nog niet beschikbaar",
  "tenantPortal.loading": "Je huurdersportaal wordt geladen...",
  "tenantPortal.loadError": "Het huurdersportaal kon niet worden geladen.",
  "tenantPortal.emptyTitle": "Nog niets om te tonen",
  "tenantPortal.emptyBody": "Zodra er in deze categorie een koppeling bestaat, verschijnt die hier automatisch.",
  "tenantPortal.empty": "Geen panden in deze lijst.",
  "tenantPortal.damageReports.title": "Schade of probleem melden",
  "tenantPortal.damageReports.helper": "Gebruik dit formulier om een probleem voor deze actieve huurovereenkomst vast te leggen.",
  "tenantPortal.damageReports.empty": "Er zijn nog geen meldingen voor deze huurovereenkomst.",
  "tenantPortal.damageReports.descriptionLabel": "Beschrijving van het probleem",
  "tenantPortal.damageReports.descriptionPlaceholder": "Beschrijf wat er aan de hand is en waar het probleem zich bevindt.",
  "tenantPortal.damageReports.photosLabel": "Foto's",
  "tenantPortal.damageReports.submit": "Melding versturen",
  "tenantPortal.damageReports.submitError": "De melding kon niet verstuurd worden.",
  "damageReports.pageDescription": "Bekijk hier alle schade- en probleemmeldingen die huurders voor je panden doorgaven.",
  "damageReports.empty": "Er zijn nog geen schade- of probleemmeldingen.",
  "damageReports.loadError": "De meldingen konden niet geladen worden.",
  "damageReports.propertyEmpty": "Er zijn nog geen meldingen voor dit pand.",
  "damageReports.openPropertyDetail": "Open het panddetail",
  "damageReports.urgency.low": "Lage urgentie",
  "damageReports.urgency.normal": "Normale urgentie",
  "damageReports.urgency.high": "Hoge urgentie",
  "damageReports.urgency.urgent": "Dringend",
  "profile.accountModeTitle": "Accountmodus",
  "profile.accountModeTenantDescription": "Je account staat in huurder-mode. Je kan zonder abonnement je kandidaturen en gekoppelde huurrelaties bekijken.",
  "profile.accountModeLandlordDescription": "Je account staat in verhuurder-mode. Je beheert het betalende platform en kan altijd terugschakelen naar huurder-mode.",
  "profile.accountModeSwitchToLandlordTitle": "Naar verhuurder-mode overschakelen?",
  "profile.accountModeSwitchToLandlordConfirm": "De verhuurder-mode geeft toegang tot het betalende platform. Je hebt een betalend abonnement nodig om deze functies te gebruiken.",
  "profile.accountModeSwitchToTenantTitle": "Naar huurder-mode overschakelen?",
  "profile.accountModeSwitchToTenantConfirm": "De huurder-mode is bedoeld wanneer je zelf panden van iemand anders wilt huren. Je gebruikt deze mode om je kandidaturen en huurrelaties te beheren.",
  "profile.switchToLandlord": "Overschakelen naar verhuurder-mode",
  "profile.switchToTenant": "Overschakelen naar huurder-mode",
  "profile.accountModeTenantActivated": "Je account staat nu in huurder-mode.",
  "profile.accountModeLandlordActivated": "Je account staat nu in verhuurder-mode.",
  "profile.accountModeLandlordTrialActivated": "Je account staat nu in verhuurder-mode en je proefperiode is gestart.",
  "profile.accountModeSwitchError": "De accountmodus kon niet worden gewijzigd.",
  "profile.accountMembers.title": "Accountleden",
  "profile.accountMembers.description": "Geef een partner, familielid of makelaar toegang tot dezelfde accountdata.",
  "profile.accountMembers.empty": "Nog geen extra accountleden.",
  "profile.accountMembers.pendingTitle": "Openstaande uitnodigingen",
  "profile.accountMembers.emailLabel": "E-mailadres",
  "profile.accountMembers.roleLabel": "Rol",
  "profile.accountMembers.role.owner": "Eigenaar",
  "profile.accountMembers.role.manager": "Mede-beheerder",
  "profile.accountMembers.role.reader": "Lezer",
  "profile.accountMembers.you": "jij",
  "profile.accountMembers.inviteButton": "Uitnodiging versturen",
  "profile.accountMembers.inviteSent": "De uitnodiging werd verstuurd.",
  "profile.accountMembers.inviteError": "De uitnodiging kon niet worden verstuurd.",
  "profile.accountMembers.claimSuccess": "De gedeelde accounttoegang is geactiveerd.",
  "profile.accountMembers.claimError": "De uitnodiging kon niet worden geactiveerd.",
  "profile.accountMembers.removeButton": "Verwijderen",
  "profile.accountMembers.removeConfirm": "Verwijder dit accountlid uit de gedeelde account?",
  "profile.accountMembers.removeSuccess": "Het accountlid werd verwijderd.",
  "profile.accountMembers.removeError": "Het accountlid kon niet worden verwijderd.",
  "profile.accountMembers.loadError": "De accountleden konden niet worden geladen.",
  "profile.accountMembers.readerProfileNotice": "Je hebt leestoegang. Alleen de eigenaar of mede-beheerder kan accountgegevens aanpassen.",
  "profile.accountMembers.readerBillingNotice": "Je hebt leestoegang. Alleen de eigenaar of mede-beheerder kan abonnementen beheren.",
  "insurance.tabTitle": "Verzekeringen",
  "insurance.add": "Verzekering toevoegen",
  "insurance.new": "Nieuwe verzekering",
  "insurance.edit": "Verzekering bewerken",
  "insurance.empty": "Nog geen verzekeringen toegevoegd voor dit pand.",
  "insurance.loadError": "Fout bij het laden van verzekeringen.",
  "insurance.confirmDelete": "Weet je zeker dat je deze verzekering wilt verwijderen?",
  "insurance.companyName": "Verzekeringsmaatschappij",
  "insurance.companyNamePlaceholder": "bv. AG Insurance, KBC, Axa",
  "insurance.policyNumber": "Polisnummer",
  "insurance.policyNumberPlaceholder": "bv. POL-2024-12345",
  "insurance.notesPlaceholder": "Optionele opmerkingen...",
  "insurance.type.Brandverzekering": "Brandverzekering",
  "insurance.type.Aansprakelijkheid": "Aansprakelijkheid",
  "insurance.type.Huurwaarborgverzekering": "Huurwaarborgverzekering",
  "insurance.type.Rechtsbijstand": "Rechtsbijstand",
  "maintenanceActivities.tabTitle": "Onderhoudslog",
  "maintenanceActivities.add": "Activiteit toevoegen",
  "maintenanceActivities.empty": "Nog geen onderhoudsactiviteiten geregistreerd voor dit pand.",
  "maintenanceActivities.descriptionPlaceholder": "Beschrijf wat er gebeurd is of gepland staat.",
  "maintenanceActivities.amountOptional": "Bedrag (optioneel)",
  "maintenanceActivities.attachmentOptional": "Bijlage (optioneel)",
  "maintenanceActivities.planned": "Gepland",
  "maintenanceActivities.completed": "Uitgevoerd",
  "maintenanceActivities.confirmDelete": "Wil je deze onderhoudsactiviteit verwijderen?",
  "maintenanceActivities.saveError": "De onderhoudsactiviteit kon niet worden opgeslagen.",
  "maintenanceActivities.uploadError": "De bijlage kon niet worden opgeladen.",
  "maintenanceActivities.category.maintenance": "Onderhoud",
  "maintenanceActivities.category.repair": "Herstelling",
  "maintenanceActivities.category.inspection": "Inspectie",
  "maintenanceActivities.category.renovation": "Renovatie",
  "maintenanceActivities.category.other": "Overig",
  "billing.newSubscriptionsDisabled": "Nieuwe abonnementen zijn momenteel tijdelijk uitgeschakeld. Lopende abonnementen en automatische verlengingen blijven wel actief.",
  "billing.userNewSubscriptionsDisabled": "Voor dit account is het starten van een nieuw betalend abonnement uitgeschakeld. Neem contact op met support als dit aangepast moet worden.",
  "admin.newSubscriptionAccess.sectionTitle": "Nieuwe abonnementen",
  "admin.newSubscriptionAccess.sectionDescription": "Bepaal of bestaande accounts zonder betaald abonnement nog een nieuw abonnement mogen starten. Lopende abonnementen en automatische verlengingen blijven gewoon doorlopen.",
  "admin.newSubscriptionAccess.enabled": "Nieuwe abonnementen toegelaten",
  "admin.newSubscriptionAccess.disabled": "Nieuwe abonnementen geblokkeerd",
  "admin.newSubscriptionAccess.toggleLabel": "Aan/uit",
  "admin.newSubscriptionAccess.saveError": "De toegang voor nieuwe abonnementen kon niet opgeslagen worden.",
  "admin.allowedCountries.sectionTitle": "Toegelaten landen",
  "admin.allowedCountries.sectionDescription": "Alleen deze landen mogen inloggen en gekozen worden in landenvelden op het platform.",
  "admin.allowedCountries.saveButton": "Landen opslaan",
  "admin.allowedCountries.saveError": "De toegelaten landen konden niet opgeslagen worden.",
  "admin.advertising.sectionTitle": "Reclameblok rechts",
  "admin.advertising.sectionDescription": "Bepaal of Rentomax op desktop een subtiele verticale advertentieruimte toont op gewone app-pagina's. Admin-pagina's tonen deze ruimte niet.",
  "admin.advertising.enabled": "Reclameblok zichtbaar",
  "admin.advertising.disabled": "Reclameblok uitgeschakeld",
  "admin.advertising.toggleLabel": "Aan/uit",
  "admin.advertising.saveError": "De advertentie-instelling kon niet opgeslagen worden."
}
